/*jshint esversion: 9 */
import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';
// import { log } from 'mathjs';

const initialState = () => ({
  // ACTION STACK (for undo/redo)
  action_stack: [],
 // meta data object (keys are keys from the ultra store)
 meta_data: {},
//types:
//Allgemein
  users: {},
// Company / Business
  businesses: {},
  broles: {},
  bpermissions: {},
  bemails: {},
  entraidmappers: {},
  allbpermissions: {},
  usersbusinesses: {},
  bproletemplates: {},
  bifcimportstrategies: {},
  clients: {},
  procoreclients: {},
  callbacks: {},
//Project
  projects: {},
  multiprojects: {},
  cloudprints: {},
  autopilots: {},
  autopilotprojects: {},
  twpmappers: {},
  gridsections: {},
//Settings
  // autopilots: {},
  autopilotissues: {},
  proles: {},
  ppermissions: {},
  allppermissions: {},
  logentries: {},
  dronejobs: {},
//Taktplan
  trains: {},
  taktareas: {},
  twaggons: {},
  tworkpackages: {},
  tags: {},
  //steps
  tworksteps: {},
  tdefectsteps: {},
  tqualitysteps: {},
  thandoversteps: {},
  tlogisticsteps: {},
  tdesignsteps: {},
  tcoststeps: {},
  tmaterialsteps: {},
  tmachinesteps: {},
  tworkpackageimages: {},
  dailyreports: {},
  milestones: {},
  tmaterials: {},
  substeps: {},

  //backlogs
  wbgroups: {},
  wblines: {},
  wbworkpackages: {},
  wbworksteps: {},
  wbdefectsteps: {},
  wbqualitysteps: {},
  wbhandoversteps: {},
  wblogisticsteps: {},
  wbdesignsteps: {},
  wbcoststeps: {},
  wbmaterialsteps: {},
  wbworkpackageimages: {},

  taktboxes: {},

//takt-space
  sites: {},
  spatialzones: {},
  buildings: {},
  buildingstoreys: {},
  // spaces: {},
  spacegroups: {},
  elementassemblies: {},
  elements: {
    // 1143856: {
    //   closed: true,
    //   created: "2023-03-21 14:20:26 UTC",
    //   description: "",
    //   express_id: null,
    //   floor_area: 0,
    //   floor_area_source: "TAKT.ing default value",
    //   geometry: {
    //     type: 'ExtrudedShape',
    //     // points: [0,0,0,1,1,0,1,1],
    //     points_x: [0,1,2,2,1,0],
    //     points_y: [0,0,0,2,1,1],
    //     // points_z: [],
    //     offset: [0,0,4], //x,y,z
    //     extrude_value: 2,
    //     normal: [0,0,1], //x,y,z
    //   },
    //   global_id: null,
    //   height: 0,
    //   height_source: "TAKT.ing default value",
    //   id: 1143856,
    //   ifc_type: "IFCBUILDINGELEMENTPROXY",
    //   lateral_surface: 0,
    //   lateral_surface_source: "TAKT.ing default value",
    //   length: 0,
    //   length_source: "TAKT.ing default value",
    //   name: "Element",
    //   order_index: 5,
    //   order_index_ta: 0,
    //   parent: {id: 4630, type: "buildingstoreys"},
    //   perimeter: 0,
    //   perimeter_source: "TAKT.ing default value",
    //   propertysets: [],
    //   ref_point: {x: 0, y: 0, z: 0},
    //   side_area: 0,
    //   side_area_source: "TAKT.ing default value",
    //   surface: 0,
    //   surface_source: "TAKT.ing default value",
    //   texture_id: null,
    //   tworksteps: [],
    //   type: "elements",
    //   updated: "2023-03-21 14:20:26 UTC",
    //   visible: false,
    //   volume: 0,
    //   volume_source: "TAKT.ing default value",
    //   weight: 0,
    //   weight_source: "TAKT.ing default value",
    //   width: 0,
    //   width_source: "TAKT.ing default value",
    //   mesh: false,
    // }
  },
  propertysets: {},
  properties: {},
  // spatialunits: {},
  plans: {},
  planversions: {},
  locations: {},

  taktareashapes: {},
  
  structurefilters: {},

  // history
  histprojects: {},
  histtrains: {},
  histtaktareas: {},
  histtwaggons: {},
  histtworkpackages: {},
  histwbgroups: {},
  histwblines: {},
  histwbworkpackages: {},
  histtworksteps: {},
  histtdefectsteps: {},
  histtqualitysteps: {},
  histthandoversteps: {},
  histtlogisticsteps: {},
  histtdesignsteps: {},
  histtcoststeps: {},
  histtmaterialsteps: {},
  histtmachinesteps: {},
  histwbdesignsteps: {},
  histwblogisticsteps: {},
  histwbmaterialsteps: {},
  histwbroboticsteps: {},
  histwbworksteps: {},
  histwbcoststeps: {},
  histwbqualitysteps: {},
  histwbdefectsteps: {},
  histwbhandoversteps: {},
  histwbmachinesteps: {},
  histwbworkpackageimages: {},

//spatial units workpackages test
  testworkpackages: {
    1: {
      id: 1,
      color: 'grey',
      token: 'EST',
      icon: 'obj-server',
      time_effort: 3
    },
    2: {
      id: 2,
      color: 'green',
      token: 'EL1',
      icon: 'obj-plug',
      time_effort: 2
    },
    3: {
      id: 3,
      color: 'teal',
      token: 'SA1',
      icon: 'obj-drop',
      time_effort: 1
    },
    4: {
      id: 4,
      color: 'orange',
      token: 'MA1',
      icon: 'tool-paint-roller',
      time_effort: 4
    },
  },

  // PAY
  payaccounts: {},
  products: {},
  shoppingcarts: {},
  shoppingcartproducts: {},
  orderedproducts: {},
// system variables
  error: '',
  cache: {},

//definitions
  definitions: {
    trains: {
      closed: true,
      type: 'trains'
    },
    wbgroups: {
      closed: true,
      type: 'wbgroups'
    },
    histwbgroups: {
      closed: true,
      type: 'histwbgroups'
    },
    taktareas: {
      closed: true,
      elements: [],
      type: 'taktareas',
      element_wrappers_open: [],
      taktareashapes: [],
    },
    histtrains: {
      closed: false,
      type: 'trains'
    },
    histtaktareas: {
      closed: false,
      elements: [],
      type: 'taktareas',
      element_wrappers_open: [],
      taktareashapes: [],
    },
    taktareashapes: {
      type: 'taktareashapes',
      lower_level: -2,
      height: 20,
      path: [],
    },
    multiprojects: {
      type: 'multiprojects',
      status: 'aaa',
      projects: [],
    },
    autopilotprojects: {
      twpmappers: []
    },
    taktboxes: {
      temperature: []
    },
    projects: {
      autopilotprojects: [],
      ppermissions: [],
      cloudprints: [],
      plans: [],
      proles: [],
      sites: [],
      logentries: [],
      step_cards: {},
      histprojects: [],
      type: 'projects',
      weather: [],
      information: {
        user_count: 0,
        trains_count: 0,
        taktareas_count: 0,
        waggons_count: 0,
        work_packages_count: 0,
        work_steps_count: 0,
        proles_count: 0,
        relations_count: 0,
        tenders_count: 0,
        milestones_count: 0,
        free_days_count: 0
      },
      reportstatusprogress: {},
      reporttradestatus: {},
      textures: {},
      showMilestones: false,
      trainsbacklogs: [],
      taktboxes: [],

      milestones: [], //fehlt
      pmilestones: [], //fehlt
      collision_weeks: [],
      free_days: [], //fehlt
      image: '', //fehlt
      invites: [], //fehlt
      invoice_address: {}, //fehlt
      prole: "", //fehlt
      users: [], //fehlt
      work_packages: [], // fehlt
      own_twork_packages: [],
      working_time_start: 0,
      working_time_duration: 86340,
      gridsections: [],
      substeps: [],
      //not nescesary:
      // created, duration, updated
      unstaged_elements: [],
      // unstaged_elements: ['1143856'],
      // unstaged_elements: [
      //   '1144315',
      //   '1144316',
      //   '1144317',
      //   '1144318',
      //   '1144319',
      //   '1144320',
      //   '1144321',
      //   '1144322',
      //   '1144323',
      //   '1144324',
      //   '1144325',
      //   '1144326',
      //   '1144327',
      //   '1144328',
      //   '1144329',
      //   '1144330',
      //   '1144331',
      //   '1144332',
      //   '1144333',
      //   '1144334',
      //   '1144335',
      //   '1144336',
      //   '1144337',
      //   '1144338',
      //   '1144339',
      //   '1144340',
      //   '1144341',
      //   '1144342',
      //   '1144343',
      //   '1144344',
      // ],
    },
    histprojects: {
      autopilotprojects: [],
      ppermissions: [],
      cloudprints: [],
      plans: [],
      proles: [],
      sites: [],
      step_cards: {},
      type: 'projects',
      weather: [],
      information: {
        user_count: 0,
        trains_count: 0,
        taktareas_count: 0,
        waggons_count: 0,
        work_packages_count: 0,
        work_steps_count: 0,
        proles_count: 0,
        relations_count: 0,
        tenders_count: 0,
        milestones_count: 0,
        free_days_count: 0
      },
      reportstatusprogress: {},
      reporttradestatus: {},
      textures: {},
      showMilestones: false,

      milestones: [], //fehlt
      pmilestones: [], //fehlt
      collision_weeks: [],
      free_days: [], //fehlt
      image: '', //fehlt
      invites: [], //fehlt
      invoice_address: {}, //fehlt
      prole: "", //fehlt
      users: [], //fehlt
      work_packages: [] // fehlt
      //not nescesary:
      // created, duration, updated
    },
    invitations: [],
    twaggons: {token: '', type: 'twaggons'},
    tworkpackages: {
      type: 'tworkpackages',
      is_open: false,
      time_effort_source: 'time_effort_planned',
      cost_strategy: {},
      // time_effort_steps: 120,
      logentries: [],
      tdesignsteps: [],
      tlogisticsteps: [],
      tmaterialsteps: [],
      troboticsteps: [],
      tworksteps: [],
      tcoststeps: [],
      tqualitysteps: [],
      tdefectsteps: [],
      thandoversteps: [],
      tmachinesteps: [],
      tworkpackageimages: [],
      dailyreports: [],
      dronejobs: [],
      //forecast information
      image_count: 0,
      log_entry_count: 1,
      message_count: 0,
      tcost_step_count: 0,
      tcoststeps_done_count: 0,
      tdefect_step_count: 0,
      tdefectsteps_done_count: 0,
      tdesign_step_count: 0,
      tdesignsteps_done_count: 0,
      thandover_step_count: 0,
      thandoversteps_done_count: 0,
      tmachine_step_count: 0,
      tmachine_steps_done_count: 0,
      time_effort_steps: 0,
      tlogistic_step_count: 0,
      tlogisticsteps_done_count: 0,
      tmaterial_step_count: 0,
      tmaterialsteps_done_count: 0,
      tquality_step_count: 0,
      tqualitysteps_done_count: 0,
      twork_step_count: 0,
      tworksteps_done_count: 0,
      carbon_dioxide: 0,
    },
    histtworkpackages: {
      is_open: false,
      time_effort_source: 'time_effort_planned',
      // time_effort_steps: 120,
      histtdesignsteps: [],
      histtlogisticsteps: [],
      histtmaterialsteps: [],
      histtroboticsteps: [],
      histtworksteps: [],
      histtcoststeps: [],
      histtqualitysteps: [],
      histtdefectsteps: [],
      histthandoversteps: [],
      histtmachinesteps: [],
      tworkpackageimages: [],
      dailyreports: [],
      //forecast information
      image_count: 0,
      log_entry_count: 1,
      message_count: 0,
      tcost_step_count: 0,
      tcoststeps_done_count: 0,
      tdefect_step_count: 0,
      tdefectsteps_done_count: 0,
      tdesign_step_count: 0,
      tdesignsteps_done_count: 0,
      thandover_step_count: 0,
      thandoversteps_done_count: 0,
      tmachine_step_count: 0,
      tmachine_steps_done_count: 0,
      time_effort_steps: 0,
      tlogistic_step_count: 0,
      tlogisticsteps_done_count: 0,
      tmaterial_step_count: 0,
      tmaterialsteps_done_count: 0,
      tquality_step_count: 0,
      tqualitysteps_done_count: 0,
      twork_step_count: 0,
      tworksteps_done_count: 0,

      costs_paid_out_total: 0,
    },
    wblines: {
      wbworkpackages: [],
    },
    wbworkpackages: {
      is_open: false,
      time_effort_source: 'time_effort_planned',
      // time_effort_steps: 120,
      cost_strategy: {},
      wbdesignsteps: [],
      wblogisticsteps: [],
      wbmaterialsteps: [],
      wbroboticsteps: [],
      wbworksteps: [],
      wbcoststeps: [],
      wbqualitysteps: [],
      wbdefectsteps: [],
      wbhandoversteps: [],
      wbmachinesteps: [],
      wbworkpackageimages: [],
      dailyreports: [],
      //forecast information
      image_count: 0,
      log_entry_count: 1,
      message_count: 0,
      wbcost_step_count: 0,
      wbcoststeps_done_count: 0,
      wbdefect_step_count: 0,
      wbdefectsteps_done_count: 0,
      wbdesign_step_count: 0,
      wbdesignsteps_done_count: 0,
      wbhandover_step_count: 0,
      wbhandoversteps_done_count: 0,
      wbime_effort_steps: 0,
      wblogistic_step_count: 0,
      wblogisticsteps_done_count: 0,
      wbmaterial_step_count: 0,
      wbquality_step_count: 0,
      wbqualitysteps_done_count: 0,
      wbmachine_step_count: 0,
      wbwork_step_count: 0,
      wbworksteps_done_count: 0,

      position: -1,
      length: 1,
      y_index: 0,
      height: 1,
      costs_paid_out_total: 0,
    },
    histwbworkpackages: {
      is_open: false,
      time_effort_source: 'time_effort_planned',
      // time_effort_steps: 120,
      cost_strategy: {},
      histwbdesignsteps: [],
      histwblogisticsteps: [],
      histwbmaterialsteps: [],
      histwbroboticsteps: [],
      histwbworksteps: [],
      histwbcoststeps: [],
      histwbqualitysteps: [],
      histwbdefectsteps: [],
      histwbhandoversteps: [],
      histwbmachinesteps: [],
      histwbworkpackageimages: [],
      dailyreports: [],
      //forecast information
      image_count: 0,
      log_entry_count: 1,
      message_count: 0,
      wbcost_step_count: 0,
      wbcoststeps_done_count: 0,
      wbdefect_step_count: 0,
      wbdefectsteps_done_count: 0,
      wbdesign_step_count: 0,
      wbdesignsteps_done_count: 0,
      wbhandover_step_count: 0,
      wbhandoversteps_done_count: 0,
      wbime_effort_steps: 0,
      wblogistic_step_count: 0,
      wblogisticsteps_done_count: 0,
      wbmaterial_step_count: 0,
      wbquality_step_count: 0,
      wbqualitysteps_done_count: 0,
      wbmachine_step_count: 0,
      wbwork_step_count: 0,
      wbworksteps_done_count: 0,

      position: -1,
      length: 1,
      y_index: 0,
      height: 1,
      costs_paid_out_total: 0,
    },
    tworkpackageimages: {
      tlogisticsteps: [],
      tdesignsteps: [],
      tworksteps: [],
      tqualitysteps: [],
      tdefectsteps: [],
      thandoversteps: [],
      tdefect_steps: [],
      tmaterialsteps: [],
      tsensorsteps: [],
      tmachinesteps: [],
      trobiticsteps: [],
    },
    tlogisticsteps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false},
    tdesignsteps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false},
    tworksteps: {showImages: false, tworkpackageimages: [], showElements: false, elements_done: [], elements: [], tags: [], tmaterialsteps: [], loaded_from_backend: false, substeps: []},
    tqualitysteps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false, substeps: []},
    tdefectsteps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false, substeps: []},
    thandoversteps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false, substeps: []},
    tdefect_steps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false, substeps: []},
    tmaterialsteps: {showImages: false, tworkpackageimages: [], showElements: false, elements: [], tags: [], tworksteps: [], loaded_from_backend: false, substeps: []},
    tsensorsteps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false, substeps: []},
    tmachinesteps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false, substeps: []},
    trobiticsteps: {showImages: false, tworkpackageimages: [], elements: [], tags: [], loaded_from_backend: false, substeps: []},
    // tmaterialsteps: {showImages: false, showElements: false, mass_relation: 'perimeter', elements: [101, 102]},

    //backlog steps
    wblogisticsteps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},
    wbdesignsteps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},
    wbworksteps: {showImages: false, showElements: false, elements_done: [], elements: [], tags: [], wbmaterialsteps: [], loaded_from_backend: false},
    wbqualitysteps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},
    wbdefectsteps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},
    wbhandoversteps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},
    wbdefect_steps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},
    wbmaterialsteps: {showImages: false, showElements: false, elements: [], tags: [], wbworksteps: [], loaded_from_backend: false},
    wbsensorsteps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},
    wbmachinesteps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},
    wbrobiticsteps: {showImages: false, elements: [], tags: [], loaded_from_backend: false},


    //project structure
    sites: {plans: [], element_wrappers_open: [], visible: true, full_fetched: false},
    spatialzones: {plans: [], element_wrappers_open: [], visible: true, full_fetched: false},
    buildings: {plans: [], element_wrappers_open: [], visible: true, full_fetched: false},
    buildingstoreys: {plans: [], element_wrappers_open: [], visible: true, full_fetched: false},
    spacegroups: {plans: [], element_wrappers_open: [], visible: true, full_fetched: false},
    elementassemblies: {plans: [], element_wrappers_open: [], visible: true, full_fetched: false},
    elements: {
      // paths: [],
      // ref_point: {x: 0, y: 0, z: 0},
      // height: 2.5,
      // floor_area: 1,
      // perimeter: 1,
      visible: true,
      // ifc_prop_sets: [],
      mesh: false,
      // links
      taktareas: [],
      // steps
      tlogisticsteps: [],
      tdesignsteps: [],
      tworksteps: [],
      tqualitysteps: [],
      tdefectsteps: [],
      thandoversteps: [],
      tmaterialsteps: [],
      tmachinesteps: [],
      full_fetched: false,
      height: 0.0,
      floor_area: 0.0,
      perimeter: 0.0,
      length: 0.0,
      width: 0.0,
      volume: 0.0,
      surface: 0.0,
      lateral_surface: 0.0,
      weight: 0.0,
      side_area: 0.0,

    },
    plans: {type: 'plans', visible: true},
    propertysets: {
      closed: true
    },
    milestones: {check_status: 'done'},
    businesses: {
      bproletemplates: [],
      bemails: [],
      projects: [],
      entraidmappers: [],
      procoreclients: [],
      clients: []
    },
    clients: {
      projects: [],
      callbacks: []
    },
    // spatialunits: {plans: [], locations: [], workpackages: []},
  },

//constants
  week_days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  week_days_full: ['Sunday', 'Monday','Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  status_array: [
    // NOTE: these are the new ticon icons
    {name: 'none', value: 'none', color: '', icon: 'checkbox-radial-empty', tooltip: 'None'},
    {name: 'ready', value: 'ready', color: 'grey lighten-2', icon: 'checked-stopwatch', tooltip: 'Ready', status_index: 1},
    {name: 'started', value: 'started', color: 'grey lighten-1', icon: 'plane-takeoff', tooltip: 'Started', status_index: 2},
    {name: 'done', value: 'done', color: 'grey darken-1', icon: 'check-large', tooltip: 'Done', status_index: 3},
    {name: 'checked', value: 'checked', color: 'grey darken-2', icon: 'thumbs-up', tooltip: 'Checked', status_index: 4},
    {name: 'closed', value: 'closed', color: 'grey darken-3', icon: 'close', tooltip: 'Closed', status_index: 5},
    {name: 'stop', value: 'stop', color: 'grey darken-4', icon: 'exclamation-triangle-negative', tooltip: 'Stop', ai_icon: 'ai', is_stop: 'stop'},

    // NOTE: these are the old font awesome icons
    // {name: 'none', value: 'none', color: '', icon: 'panorama_fish_eye', tooltip: 'None'},
    // {name: 'ready', value: 'ready', color: 'grey lighten-2', icon: 'alarm_on', tooltip: 'Ready', status_index: 1},
    // {name: 'started', value: 'started', color: 'grey lighten-1', icon: 'flight_takeoff', tooltip: 'Started', status_index: 2},
    // {name: 'done', value: 'done', color: 'grey darken-1', icon: 'done', tooltip: 'Done', status_index: 3},
    // {name: 'checked', value: 'checked', color: 'grey darken-2', icon: 'thumb_up', tooltip: 'Checked', status_index: 4},
    // {name: 'closed', value: 'closed', color: 'grey darken-3', icon: 'close', tooltip: 'Closed', status_index: 5},
    // {name: 'stop', value: 'stop', color: 'grey darken-4', icon: 'warning', tooltip: 'Stop', ai_icon: 'ai', is_stop: 'stop'},
  
  ],
  tree_wrapper: [
    { type: 'sites', name: 'sites', icon: 'simulation-03-bottom-connector'},
    { type: 'spatialzones', name: 'spatialzones', icon: 'simulation-05-top-connector'},
    { type: 'buildings', name: 'buildings', icon: 'company'},
    { type: 'buildingstoreys', name: 'buildingstoreys', icon: 'takt-structure'},
    { type: 'spacegroups', name: 'spacegroups', icon: 'construction-palett'},
    { type: 'elementassemblies', name: 'elementassemblies', icon: 'column'},
    { type: 'elements', name: 'elements', icon: 'column-rounded'},
    { type: 'object_wrapper', name: 'type wrapper', icon: 'column-rounded'},
    { type: 'plans', name: 'plans', icon: 'plan'},

    { type: 'projects', name: 'projects', icon: 'takt-plan'},
    { type: 'trains', name: 'trains', icon: 'takt-plan-train'},
    { type: 'taktareas', name: 'taktareas', icon: 'takt-plan-sequence'},
    { type: 'twaggons', name: 'twaggons', icon: 'takt-plan-waggon'},
    { type: 'tworkpackages', name: 'tworkpackages', icon: 'takt-plan-workpackage'},
    { type: 'tworksteps', name: 'tworksteps', icon: 'person-helmet'},
  ],

  // ifc icons
  icon_by_type: {
    sites: 'simulation-03-bottom-connector',
    spatialzones: 'simulation-05-top-connector',
    buildings: 'company',
    buildingstoreys: 'takt-structure',
    spacegroups: 'construction-palett',
    elementassemblies: 'column',
    elements: 'column-rounded',
    object_wrapper: 'column-rounded',
    plans: 'plan',
    projects: 'takt-plan',
    trains: 'takt-plan-train',
    taktareas: 'takt-plan-sequence',
    twaggons: 'takt-plan-waggon',
    tworkpackages: 'takt-plan-workpackage',
    tworksteps: 'person-helmet',
  },

  // ifc names
  ifc_name_by_type: {
    sites: 'Site',
    spatialzones: 'Spatial Zone',
    buildings: 'Building',
    buildingstoreys: 'Building Storey',
    spacegroups: 'Space',
    elementassemblies: 'Element Assembly',
    elements: 'Element',
    projects: 'Project',
  },

  standard_icons: [
    'add','radio_button_unchecked', 'radio_button_checked', 'title',
    'expand_more', 'stars', 'room', 'settings', 'album', 'broken_image', 'high_quality',
    'design_services', 'airport_shuttle', 'thumbs_up_down', 'list'
  ],
  usericons: [],
  usercolors: [],
  svg_icons: [
  'human-helmet',           'human-king',         'human-king-2',
  'human-stars',            'human-worker',       'obj-barbell',
  'obj-bin',                'obj-brick',          'obj-brick-wall',
  'obj-brick-wall-2',       'obj-building',       'obj-bullhorn',
  'obj-camera',             'obj-camera-2',       'obj-clock',
  'obj-clock-2',            'obj-cog',            'obj-cogs',
  'obj-construction-plan',  'obj-couch',          'obj-display',
  'obj-door',               'obj-drainage-pipe',  'obj-drop',
  'obj-drop-white',         'obj-floor',          'obj-floor-2',
  'obj-floor-3',            'obj-floor-coating',  'obj-floor-double',
  'obj-floor-screed',       'obj-light-bulb',     'obj-mic',
  'obj-package',            'obj-package-2',      'obj-package-3',
  'obj-package-4',          'obj-phone',          'obj-phone-mobile',
  'obj-plug',               'obj-plug-2',         'obj-plug-3',
  'obj-radiator',           'obj-roof',           'obj-roof-2',
  'obj-roof-3',             'obj-roof-3-white',   'obj-server',
  'obj-steel',              'obj-structure',      'obj-t-beam',
  'obj-traffic-cone',       'obj-window',         'obj-window-2',
  'sign-accessibility',     'sign-attention',     'sign-fire',
  'sign-fire-2',            'sign-radio-waves',   'sign-steam',
  'sign-toxic',             'sign-warning',       'sign-warning-2',
  'sign-weather',           'sign-weather-2',     'sign-weather-2-white',
  'sign-weather-3',         'sign-weather-4',     'sign-weather-white',
  'sign-x',                 'symbol-cold',        'symbol-connection',
  'symbol-electro',         'symbol-layer',       'symbol-link',
  'symbol-resize',          'symbol-sanitation',  'symbol-share',
  'symbol-stone-cutter',    'symbol-ventilation', 'symbol-ventilation-2',
  'takt_ai',                'takt_company',       'takt_defect',
  'takt_design',            'takt_handover',      'takt_journal',
  'takt_logistic',          'takt_material',      'takt_project',
  'takt_quality',           'takt_taktplan',      'takt_taktspace',
  'takt_wallet',            'takt_workbench',     'takt_workstep',
  'tool-cutter',            'tool-hammer',        'tool-paint-brush',
  'tool-paint-brush-clean', 'tool-paint-bucket',  'tool-paint-roller',
  'tool-paint-roller-2',    'tool-planer',        'tool-ruler',
  'tool-screw',             'tool-trowel',        'tool-wrench',
  'tools-axe-logs',         'tools-hammer-screwdriver',
  'tools-pencil-ruler',     'tools-pipe-wrench-screwdriver',
  'tools-saw-log',          'vehicle-crane',      'vehicle-excavator',
  'vehicle-excavator-2',    'vehicle-truck-delivery',
  'vehicle-truck-delivery-2',                     'vehicle-truck-delivery-3',
  'vehicle-truck-mining',   'vehicle-truck-mixer','vehicle-wheelbarrow'
  ],
  expense_units: [
    {value: 'lateral_surface', text: 'lateral-surface', name: 'lateral-surface', unit: 'm²'},
    {value: 'perimeter', text: 'perimeter', name: 'perimeter', unit: 'm'},
    {value: 'floor_area', text: 'floor-area', name: 'floor-area', unit: 'm²'},
    {value: 'ceiling_area', text: 'ceiling-area', name: 'ceiling-area', unit: 'm²'},
    {value: 'volume', text: 'volume', name: 'volume', unit: 'm³'},
    {value: 'height', text: 'height', name: 'height', unit: 'm'},
    {value: 'length', text: 'length', name: 'length', unit: 'm'},
    {value: 'width', text: 'width', name: 'width', unit: 'm'},
    {value: 'weight', text: 'weight', name: 'weight', unit: 'm²'},
    {value: 'side_area', text: 'side-area', name: 'side-area', unit: 'm²'},
    {value: 'count', text: 'count', name: 'count', unit: 'elem.'},
    {value: 'absolute', text: 'absolute', name: 'absolute', unit: ''},
    {value: 'surface', text: 'surface', name: 'surface', unit: 'm²'},
    {value: 'none', text: 'None', name: 'None', unit: 'nn'},
  ],
  ifc_geometry_values: [
    {prop: 'height', text: 'Height'},
    {prop: 'width', text: 'Width'},
    {prop: 'length', text: 'Length'},
    {prop: 'volume', text: 'Volume'},
    {prop: 'floor_area', text: 'Floor Area'},
    {prop: 'side_area', text: 'Side Area'},
    {prop: 'perimeter', text: 'Perimeter'},
    {prop: 'surface', text: 'Surface'},
    {prop: 'lateral_surface', text: 'Lateral Surface'},
    {prop: 'weight', text: 'Weight'},

  ],
  ifc_types: [
    {text: 'IFCPROJECT', value: 'IFCPROJECT'},
    {text: 'IFCSITE', value: 'IFCSITE'},
    {text: 'IFCBUILDING', value: 'IFCBUILDING'},
    {text: 'IFCBUILDINGSTOREY', value: 'IFCBUILDINGSTOREY'},
    {text: 'IFCSPACE', value: 'IFCSPACE'},
    {text: 'IFCACTUATOR', value: 'IFCACTUATOR'},
    {text: 'IFCALARM', value: 'IFCALARM'},
    {text: 'IFCANNOTATION', value: 'IFCANNOTATION'},
    {text: 'IFCAIRTERMINAL', value: 'IFCAIRTERMINAL'},
    {text: 'IFCAIRTERMINALBOX', value: 'IFCAIRTERMINALBOX'},
    {text: 'IFCAIRTOAIRHEATRECOVERY', value: 'IFCAIRTOAIRHEATRECOVERY'},
    {text: 'IFCAUDIOVISUALAPPLIANCE', value: 'IFCAUDIOVISUALAPPLIANCE'},
    {text: 'IFCBEAM', value: 'IFCBEAM'},
    {text: 'IFCBEAMSTANDARDCASE', value: 'IFCBEAMSTANDARDCASE'},
    {text: 'IFCBUILDINGELEMENTPART', value: 'IFCBUILDINGELEMENTPART'},
    {text: 'IFCBUILDINGELEMENTPROXY', value: 'IFCBUILDINGELEMENTPROXY'},
    {text: 'IFCBOILER', value: 'IFCBOILER'},
    {text: 'IFCBURNER', value: 'IFCBURNER'},
    {text: 'IFCCABLECARRIERFITTING', value: 'IFCCABLECARRIERFITTING'},
    {text: 'IFCCABLECARRIERSEGMENT', value: 'IFCCABLECARRIERSEGMENT'},
    {text: 'IFCCABLEFITTING', value: 'IFCCABLEFITTING'},
    {text: 'IFCCABLESEGMENT', value: 'IFCCABLESEGMENT'},
    {text: 'IFCCHIMNEY', value: 'IFCCHIMNEY'},
    {text: 'IFCCHILLER', value: 'IFCCHILLER'},
    {text: 'IFCCOLUMN', value: 'IFCCOLUMN'},
    {text: 'IFCCOLUMNSTANDARDCASE', value: 'IFCCOLUMNSTANDARDCASE'},
    {text: 'IFCCOMMUNICATIONSAPPLIANCE', value: 'IFCCOMMUNICATIONSAPPLIANCE'},
    {text: 'IFCCOMPRESSOR', value: 'IFCCOMPRESSOR'},
    {text: 'IFCCONDENSER', value: 'IFCCONDENSER'},
    {text: 'IFCCOOLINGTOWER', value: 'IFCCOOLINGTOWER'},
    {text: 'IFCCOOLEDBEAM', value: 'IFCCOOLEDBEAM'},
    {text: 'IFCCOIL', value: 'IFCCOIL'},
    {text: 'IFCCONTROLLER', value: 'IFCCONTROLLER'},
    {text: 'IFCCOVERING', value: 'IFCCOVERING'},
    {text: 'IFCCURTAINWALL', value: 'IFCCURTAINWALL'},
    {text: 'IFCCIVILELEMENT', value: 'IFCCIVILELEMENT'},
    {text: 'IFCDAMPER', value: 'IFCDAMPER'},
    {text: 'IFCDOOR', value: 'IFCDOOR'},
    {text: 'IFCDOORSTANDARDCASE', value: 'IFCDOORSTANDARDCASE'},
    {text: 'IFCDISTRIBUTIONCHAMBERELEMENT', value: 'IFCDISTRIBUTIONCHAMBERELEMENT'},
    {text: 'IFCDISTRIBUTIONCONTROLELEMENT', value: 'IFCDISTRIBUTIONCONTROLELEMENT'},
    {text: 'IFCDISTRIBUTIONELEMENT', value: 'IFCDISTRIBUTIONELEMENT'},
    {text: 'IFCDISTRIBUTIONFLOWELEMENT', value: 'IFCDISTRIBUTIONFLOWELEMENT'},
    {text: 'IFCDISCRETEACCESSORY', value: 'IFCDISCRETEACCESSORY'},
    {text: 'IFCDUCTFITTING', value: 'IFCDUCTFITTING'},
    {text: 'IFCDUCTSEGMENT', value: 'IFCDUCTSEGMENT'},
    {text: 'IFCDUCTSILENCER', value: 'IFCDUCTSILENCER'},
    {text: 'IFCELECTRICAPPLIANCE', value: 'IFCELECTRICAPPLIANCE'},
    {text: 'IFCELECTRICDISTRIBUTIONBOARD', value: 'IFCELECTRICDISTRIBUTIONBOARD'},
    {text: 'IFCELECTRICFLOWSTORAGEDEVICE', value: 'IFCELECTRICFLOWSTORAGEDEVICE'},
    {text: 'IFCELECTRICGENERATOR', value: 'IFCELECTRICGENERATOR'},
    {text: 'IFCELECTRICMOTOR', value: 'IFCELECTRICMOTOR'},
    {text: 'IFCELECTRICTIMECONTROL', value: 'IFCELECTRICTIMECONTROL'},
    {text: 'IFCENERGYCONVERSIONDEVICE', value: 'IFCENERGYCONVERSIONDEVICE'},
    {text: 'IFCELEMENTASSEMBLY', value: 'IFCELEMENTASSEMBLY'},
    {text: 'IFCENGINE', value: 'IFCENGINE'},
    {text: 'IFCEVAPORATOR', value: 'IFCEVAPORATOR'},
    {text: 'IFCEVAPORATIVECOOLER', value: 'IFCEVAPORATIVECOOLER'},
    {text: 'IFCFASTENER', value: 'IFCFASTENER'},
    {text: 'IFCFAN', value: 'IFCFAN'},
    {text: 'IFCFILTER', value: 'IFCFILTER'},
    {text: 'IFCFIRESUPPRESSIONTERMINAL', value: 'IFCFIRESUPPRESSIONTERMINAL'},
    {text: 'IFCFLOWCONTROLLER', value: 'IFCFLOWCONTROLLER'},
    {text: 'IFCFLOWFITTING', value: 'IFCFLOWFITTING'},
    {text: 'IFCFLOWINSTRUMENT', value: 'IFCFLOWINSTRUMENT'},
    {text: 'IFCFLOWMETER', value: 'IFCFLOWMETER'},
    {text: 'IFCFLOWMOVINGDEVICE', value: 'IFCFLOWMOVINGDEVICE'},
    {text: 'IFCFLOWSEGMENT', value: 'IFCFLOWSEGMENT'},
    {text: 'IFCFLOWSTORAGEDEVICE', value: 'IFCFLOWSTORAGEDEVICE'},
    {text: 'IFCFLOWTERMINAL', value: 'IFCFLOWTERMINAL'},
    {text: 'IFCFLOWTREATMENTDEVICE', value: 'IFCFLOWTREATMENTDEVICE'},
    {text: 'IFCFURNISHINGELEMENT', value: 'IFCFURNISHINGELEMENT'},
    {text: 'IFCFURNITURE', value: 'IFCFURNITURE'},
    {text: 'IFCFOOTING', value: 'IFCFOOTING'},
    {text: 'IFCGEOGRAPHICELEMENT', value: 'IFCGEOGRAPHICELEMENT'},
    {text: 'IFCHEATEXCHANGER', value: 'IFCHEATEXCHANGER'},
    {text: 'IFCHUMIDIFIER', value: 'IFCHUMIDIFIER'},
    {text: 'IFCINTERCEPTOR', value: 'IFCINTERCEPTOR'},
    {text: 'IFCJUNCTIONBOX', value: 'IFCJUNCTIONBOX'},
    {text: 'IFCLAMP', value: 'IFCLAMP'},
    {text: 'IFCLIGHTFIXTURE', value: 'IFCLIGHTFIXTURE'},
    {text: 'IFCPILE', value: 'IFCPILE'},
    {text: 'IFCPIPEFITTING', value: 'IFCPIPEFITTING'},
    {text: 'IFCPIPESEGMENT', value: 'IFCPIPESEGMENT'},
    {text: 'IFCPLATE', value: 'IFCPLATE'},
    {text: 'IFCPLATESTANDARDCASE', value: 'IFCPLATESTANDARDCASE'},
    {text: 'IFCPROJECTIONELEMENT', value: 'IFCPROJECTIONELEMENT'},
    {text: 'IFCPROTECTIVEDEVICE', value: 'IFCPROTECTIVEDEVICE'},
    {text: 'IFCPROTECTIVEDEVICETRIPPINGUNIT', value: 'IFCPROTECTIVEDEVICETRIPPINGUNIT'},
    {text: 'IFCPUMP', value: 'IFCPUMP'},
    {text: 'IFCSANITARYTERMINAL', value: 'IFCSANITARYTERMINAL'},
    {text: 'IFCSHADINGDEVICE', value: 'IFCSHADINGDEVICE'},
    {text: 'IFCSLAB', value: 'IFCSLAB'},
    {text: 'IFCSLABELEMENTEDCASE', value: 'IFCSLABELEMENTEDCASE'},
    {text: 'IFCSLABSTANDARDCASE', value: 'IFCSLABSTANDARDCASE'},
    {text: 'IFCSOLARDEVICE', value: 'IFCSOLARDEVICE'},
    {text: 'IFCSPACEHEATER', value: 'IFCSPACEHEATER'},
    {text: 'IFCSTACKTERMINAL', value: 'IFCSTACKTERMINAL'},
    {text: 'IFCSTAIR', value: 'IFCSTAIR'},
    {text: 'IFCSTAIRFLIGHT', value: 'IFCSTAIRFLIGHT'},
    {text: 'IFCSYSTEMFURNITUREELEMENT', value: 'IFCSYSTEMFURNITUREELEMENT'},
    {text: 'IFCSWITCHINGDEVICE', value: 'IFCSWITCHINGDEVICE'},
    {text: 'IFCSURFACEFEATURE', value: 'IFCSURFACEFEATURE'},
    {text: 'IFCSENSOR', value: 'IFCSENSOR'},
    {text: 'IFCTANK', value: 'IFCTANK'},
    {text: 'IFCTRANSPORTELEMENT', value: 'IFCTRANSPORTELEMENT'},
    {text: 'IFCTENDON', value: 'IFCTENDON'},
    {text: 'IFCTENDONANCHOR', value: 'IFCTENDONANCHOR'},
    {text: 'IFCTRANSFORMER', value: 'IFCTRANSFORMER'},
    {text: 'IFCTUBEBUNDLE', value: 'IFCTUBEBUNDLE'},
    {text: 'IFCMECHANICALFASTENER', value: 'IFCMECHANICALFASTENER'},
    {text: 'IFCMEDICALDEVICE', value: 'IFCMEDICALDEVICE'},
    {text: 'IFCMEMBER', value: 'IFCMEMBER'},
    {text: 'IFCMEMBERSTANDARDCASE', value: 'IFCMEMBERSTANDARDCASE'},
    {text: 'IFCMOTORCONNECTION', value: 'IFCMOTORCONNECTION'},
    {text: 'IFCOPENINGELEMENT', value: 'IFCOPENINGELEMENT'},
    {text: 'IFCOPENINGSTANDARDCASE', value: 'IFCOPENINGSTANDARDCASE'},
    {text: 'IFCOUTLET', value: 'IFCOUTLET'},
    {text: 'IFCRAILING', value: 'IFCRAILING'},
    {text: 'IFCRAMP', value: 'IFCRAMP'},
    {text: 'IFCRAMPFLIGHT', value: 'IFCRAMPFLIGHT'},
    {text: 'IFCREINFORCINGBAR', value: 'IFCREINFORCINGBAR'},
    {text: 'IFCREINFORCINGMESH', value: 'IFCREINFORCINGMESH'},
    {text: 'IFCROOF', value: 'IFCROOF'},
    {text: 'IFCUNITARYCONTROLELEMENT', value: 'IFCUNITARYCONTROLELEMENT'},
    {text: 'IFCUNITARYEQUIPMENT', value: 'IFCUNITARYEQUIPMENT'},
    {text: 'IFCVALVE', value: 'IFCVALVE'},
    {text: 'IFCVIBRATIONISOLATOR', value: 'IFCVIBRATIONISOLATOR'},
    {text: 'IFCVOIDINGFEATURE', value: 'IFCVOIDINGFEATURE'},
    {text: 'IFCVIRTUALELEMENT', value: 'IFCVIRTUALELEMENT'},
    {text: 'IFCWALL', value: 'IFCWALL'},
    {text: 'IFCWALLELEMENTEDCASE', value: 'IFCWALLELEMENTEDCASE'},
    {text: 'IFCWALLSTANDARDCASE', value: 'IFCWALLSTANDARDCASE'},
    {text: 'IFCWINDOW', value: 'IFCWINDOW'},
    {text: 'IFCWINDOWSTANDARDCASE', value: 'IFCWINDOWSTANDARDCASE'},
    {text: 'IFCWASTETERMINAL', value: 'IFCWASTETERMINAL'},
  ],
  conversion_units: [
    {value: 'meter', text: 'Meter', unit: 'm'},
    {value: 'squaremeter', text: 'Square Meter', unit: 'm²'},
    {value: 'cubicmeter', text: 'Cubic Meter', unit: 'm³'},
    {value: 'liter', text: 'Liter', unit: 'l'},
    {value: 'piece', text: 'Piece', unit: 'pc'},
    {value: 'units', text: 'units', unit: 'u'},
    {value: 'none', text: 'None', unit: 'nn'},
  ],
  step_icons: {
    logistic: 'truck-container',
    design: 'crossed-pencil-ruler',
    work: 'person-helmet',
    quality: 'speech-bubble-check',
    defect: 'fragile',
    handover: 'handshake',
    material: 'wall-brick',
    machine: 'crane',
    tool: 'crossed-hammer-screwdriver',
    sensor: 'signal',
    robotic: 'cup',
    // logistic: 'mdi-truck-cargo-container',
    // design: 'mdi-pencil-ruler',
    // work: 'mdi-account-hard-hat',
    // quality: 'mdi-comment-check-outline',
    // defect: 'mdi-glass-fragile',
    // handover: 'mdi-handshake',
    // material: 'mdi-wall',
    // machine: 'vehicle-crane',
    // tool: 'mdi-hammer-screwdriver',
    // sensor: 'mdi-signal-variant',
    // robotic: 'mdi-robot-happy-outline',
  },
  step_types: ['design', 'logistic', 'material', 'robotic', 'work', 'cost', 'quality', 'defect', 'handover'],
  step_types_full: [
    'tlogisticsteps',
    'tdesignsteps',
    'tworksteps',
    'tqualitysteps',
    'tdefectsteps',
    'thandoversteps',
    'tmaterialsteps',
    'tmachinesteps',
  ],
  icons: [
    {id: 'air', hashtags: ['air']}, {id: 'antenna', hashtags: ['antenna']}, {id: 'area-empty', hashtags: ['area']}, {id: 'area-shaded', hashtags: ['area']}, {id: 'area', hashtags: ['area']}, {id: 'baloons', hashtags: ['baloons']}, {id: 'barrier', hashtags: ['barrier']}, {id: 'beam-long', hashtags: ['beam']}, {id: 'beam-perspective', hashtags: ['beam']}, {id: 'beam-short', hashtags: ['beam']}, {id: 'beard', hashtags: ['beard']}, {id: 'bearing', hashtags: ['bearing']}, {id: 'beer', hashtags: ['beer']}, {id: 'bin', hashtags: ['bin']}, {id: 'boot', hashtags: ['boot']}, {id: 'brand-bmw', hashtags: ['brand']}, {id: 'brand-creature', hashtags: ['brand']}, {id: 'brand-takting', hashtags: ['brand']}, {id: 'brand-yit', hashtags: ['brand']}, {id: 'bridge-bearing', hashtags: ['bridge-bearing']}, {id: 'broom', hashtags: ['broom']}, {id: 'bucket', hashtags: ['bucket']}, {id: 'bucket-wheel-excavator', hashtags: ['bucket']}, {id: 'cable', hashtags: ['cable']}, {id: 'cake', hashtags: ['cake']}, {id: 'calculator', hashtags: ['calculator']}, {id: 'caliper', hashtags: ['caliper']}, {id: 'camera-simple', hashtags: ['camera']}, {id: 'camera', hashtags: ['camera']}, {id: 'car', hashtags: ['car']}, {id: 'carpet', hashtags: ['carpet']}, {id: 'carton', hashtags: ['carton']}, {id: 'cat', hashtags: ['cat']}, {id: 'cement', hashtags: ['cement']}, {id: 'chainsaw', hashtags: ['chainsaw']}, {id: 'chemical', hashtags: ['chemical']}, {id: 'chimney-masonry', hashtags: ['chimney']}, {id: 'chopping', hashtags: ['chopping']}, {id: 'cleaning-trowel-rectangle', hashtags: ['cleaning']}, {id: 'cleaning-trowel-triangle', hashtags: ['cleaning']}, {id: 'cleaning', hashtags: ['cleaning']}, {id: 'clock-negative', hashtags: ['clock']}, {id: 'clock', hashtags: ['clock']}, {id: 'close-octagon', hashtags: ['close']}, {id: 'cloud-and-sun', hashtags: ['cloud']}, {id: 'cloud-rain', hashtags: ['cloud']}, {id: 'cloud', hashtags: ['cloud']}, {id: 'clouds-broken', hashtags: ['clouds']},{id: 'clouds-lightning', hashtags: ['clouds']}, {id: 'coating', hashtags: ['coating']}, {id: 'column-rounded', hashtags: ['column']}, {id: 'column', hashtags: ['column']}, {id: 'compass', hashtags: ['compass']}, {id: 'con-rod-negative', hashtags: ['con']}, {id: 'con-rod', hashtags: ['con']}, {id: 'concrete-mixer', hashtags: ['concrete']}, {id: 'construction-palett', hashtags: ['construction']}, {id: 'construction-spotlight', hashtags: ['construction']}, {id: 'container-perspective', hashtags: ['container']}, {id: 'container-pulled-up', hashtags: ['container']}, {id: 'coordinates', hashtags: ['coordinates']}, {id: 'cordless-screwdriver', hashtags: ['cordless']}, {id: 'core-drill', hashtags: ['core']}, {id: 'couch', hashtags: ['couch']}, {id: 'covering', hashtags: ['covering']}, {id: 'crane', hashtags: ['crane']}, {id: 'crash-barrier', hashtags: ['crash']}, {id: 'crossed-hammer-screwdriver', hashtags: ['crossed']}, {id: 'crossed-pencil-ruler', hashtags: ['crossed']}, {id: 'crossed-wrench-screwdriver', hashtags: ['crossed']}, {id: 'crown', hashtags: ['crown']}, {id: 'cube-negative', hashtags: ['cube']}, {id: 'cube-nubs', hashtags: ['cube']}, {id: 'cube-top', hashtags: ['cube']}, {id: 'cube', hashtags: ['cube']}, {id: 'cup', hashtags: ['cup']}, {id: 'cutter', hashtags: ['cutter']}, {id: 'cycle', hashtags: ['cycle']}, {id: 'dirndl', hashtags: ['dirndl']}, {id: 'door-open', hashtags: ['door']}, {id: 'door', hashtags: ['door']}, {id: 'drainage-droplet', hashtags: ['drainage']}, {id: 'drainage-waves', hashtags: ['drainage']}, {id: 'droplet-splash', hashtags: ['droplet']}, {id: 'drywall', hashtags: ['drywall']}, {id: 'dumbbell', hashtags: ['dumbbell']}, {id: 'dunce', hashtags: ['dunce']}, {id: 'elevator', hashtags: ['elevator']}, {id: 'electrical-grounding', hashtags: ['electrical']}, {id: 'empty-paper', hashtags: ['empty']}, {id: 'excavation', hashtags: ['excavation']}, {id: 'excavation-container', hashtags: ['excavation']}, {id: 'excavation-passage', hashtags: ['excavation']}, {id: 'excavator-large', hashtags: ['excavator']}, {id: 'excavator', hashtags: ['excavator']}, {id: 'exclamation-octagon', hashtags: ['exclamation']}, {id: 'exclamation-triangle-negative', hashtags: ['exclamation']}, {id: 'exclamation-triangle', hashtags: ['exclamation']}, {id: 'explosion', hashtags: ['explosion']}, {id: 'fence', hashtags: ['fence']}, {id: 'finish-line', hashtags: ['finish']}, {id: 'fire-extinguisher', hashtags: ['fire']}, {id: 'flag-simple', hashtags: ['flag']}, {id: 'flag', hashtags: ['flag']}, {id: 'flame-negative', hashtags: ['flame']}, {id: 'flame', hashtags: ['flame']}, {id: 'floors', hashtags: ['floors']}, {id: 'flower', hashtags: ['flower']}, {id: 'footing', hashtags: ['footing']}, {id: 'fork-lift', hashtags: ['fork']}, {id: 'garage-door', hashtags: ['garage']}, {id: 'garage', hashtags: ['garage']}, {id: 'gear-defect', hashtags: ['gear']}, {id: 'gear', hashtags: ['gear']}, {id: 'gears', hashtags: ['gears']}, {id: 'globe', hashtags: ['globe']}, {id: 'glove', hashtags: ['glove']}, {id: 'goblet', hashtags: ['goblet']}, {id: 'ground-earth', hashtags: ['ground']}, {id: 'ground-gravel', hashtags: ['ground']}, {id: 'ground-sand', hashtags: ['ground']}, {id: 'hammer', hashtags: ['hammer']}, {id: 'hashtag', hashtags: ['hashtag']}, {id: 'heart', hashtags: ['heart']}, {id: 'helmet', hashtags: ['helmet']}, {id: 'hook', hashtags: ['hook']}, {id: 'house-chimney', hashtags: ['house']}, {id: 'house-flat-roof', hashtags: ['house']}, {id: 'house-split', hashtags: ['house']}, {id: 'infinity', hashtags: ['infinity']}, {id: 'insulation', hashtags: ['insulation']}, {id: 'jackhammer', hashtags: ['jackhammer']}, {id: 'key-modern', hashtags: ['key']}, {id: 'key-old', hashtags: ['key']}, {id: 'ladder', hashtags: ['ladder']}, {id: 'laptop', hashtags: ['laptop']}, {id: 'leather-pants', hashtags: ['leather']}, {id: 'led', hashtags: ['led']}, {id: 'lift-up', hashtags: ['lift']}, {id: 'light-bulb-capsule', hashtags: ['light']}, {id: 'light-bulb-pear', hashtags: ['light']}, {id: 'link', hashtags: ['link']}, {id: 'lock', hashtags: ['lock']}, {id: 'location', hashtags: ['location']}, {id: 'logistic', hashtags: ['logistic']}, {id: 'lucky', hashtags: ['lucky']}, {id: 'magnifying-glass', hashtags: ['magnifying']}, {id: 'measure', hashtags: ['measure']}, {id: 'megaphone', hashtags: ['megaphone']}, {id: 'metal-saw', hashtags: ['metal']}, {id: 'microphone', hashtags: ['microphone']}, {id: 'mobile-phone', hashtags: ['mobile']}, {id: 'money', hashtags: ['money']}, {id: 'moon', hashtags: ['moon']}, {id: 'mooring-device', hashtags: ['mooring-device']}, {id: 'nail', hashtags: ['nail']}, {id: 'no-walking', hashtags: ['no']}, {id: 'nut-perspective', hashtags: ['nut']}, {id: 'nut-top', hashtags: ['nut']}, {id: 'packet', hashtags: ['packet']}, {id: 'paint-brush', hashtags: ['paint']}, {id: 'paint-bucket', hashtags: ['paint']}, {id: 'paint-frame', hashtags: ['paint']}, {id: 'paint-roller-negative', hashtags: ['paint']}, {id: 'paint-roller', hashtags: ['paint']}, {id: 'paling', hashtags: ['paling']}, {id: 'panda', hashtags: ['panda']}, {id: 'paper-roll', hashtags: ['paper']}, {id: 'parquet-tile', hashtags: ['parquet']}, {id: 'parquet', hashtags: ['parquet']}, {id: 'pavement', hashtags: ['pavement']}, {id: 'person-crowned', hashtags: ['person']}, {id: 'person-helmet', hashtags: ['person']}, {id: 'person-standing', hashtags: ['person']}, {id: 'person-stars', hashtags: ['person']}, {id: 'person', hashtags: ['person']}, {id: 'persons-two', hashtags: ['persons']}, {id: 'perspective-ceiling', hashtags: ['perspective']}, {id: 'perspective-floor', hashtags: ['perspective']}, {id: 'perspective-walls', hashtags: ['perspective']}, {id: 'phone', hashtags: ['phone']}, {id: 'pin', hashtags: ['pin']}, {id: 'pipes-connected', hashtags: ['pipes']}, {id: 'pipes-u-shaped', hashtags: ['pipes']}, {id: 'plan-cog', hashtags: ['plan']}, {id: 'plan-project', hashtags: ['plan']}, {id: 'plan', hashtags: ['plan']}, {id: 'plane', hashtags: ['plane']}, {id: 'plant', hashtags: ['plant']}, {id: 'plate', hashtags: ['plate']}, {id: 'pouring-diagonal', hashtags: ['pouring']}, {id: 'pouring-horizontal', hashtags: ['pouring']}, {id: 'power-plug-rounded', hashtags: ['power']}, {id: 'power-plug-sharp', hashtags: ['power']}, {id: 'power-plug-slim', hashtags: ['power']}, {id: 'power-socket-a', hashtags: ['power']}, {id: 'power-socket-b', hashtags: ['power']}, {id: 'power-socket-c', hashtags: ['power']}, {id: 'power-socket-f', hashtags: ['power']}, {id: 'power-socket-i', hashtags: ['power']}, {id: 'present', hashtags: ['present']}, {id: 'pretzel', hashtags: ['pretzel']}, {id: 'proxy', hashtags: ['proxy']}, {id: 'pull', hashtags: ['pull']}, {id: 'puzzle', hashtags: ['puzzle']}, {id: 'pylon', hashtags: ['pylon']}, {id: 'quality', hashtags: ['quality']}, {id: 'radiator-capsule', hashtags: ['radiator']}, {id: 'radiator-rectangle', hashtags: ['radiator']}, {id: 'rail-tracks', hashtags: ['rail']}, {id: 'rail-perspective', hashtags: ['rail']},{id: 'railing', hashtags: ['railing']}, {id: 'raised-floor', hashtags: ['raised']}, {id: 'rebar', hashtags: ['rebar']}, {id: 'road-roller', hashtags: ['road']}, {id: 'roll-out', hashtags: ['roll']}, {id: 'roll', hashtags: ['roll']}, {id: 'roof-perspective', hashtags: ['roof']}, {id: 'roof-profile', hashtags: ['roof']}, {id: 'roof-tile-single', hashtags: ['roof']}, {id: 'roof-tiles-wavy', hashtags: ['roof']}, {id: 'roof-tiles', hashtags: ['roof']}, {id: 'ruler', hashtags: ['ruler']}, {id: 'sack', hashtags: ['sack']}, {id: 'safety-glasses', hashtags: ['safety']}, {id: 'saw-blade', hashtags: ['saw']}, {id: 'saw', hashtags: ['saw']}, {id: 'sawing', hashtags: ['sawing']}, {id: 'scaffolding', hashtags: ['scaffolding']}, {id: 'scissor-lift', hashtags: ['scissor']}, {id: 'scraper', hashtags: ['scraper']}, {id: 'screen', hashtags: ['screen']}, {id: 'screw-head-cross', hashtags: ['screw']}, {id: 'screw-head-hexagon', hashtags: ['screw']}, {id: 'screw-head-slit', hashtags: ['screw']}, {id: 'screw', hashtags: ['screw']}, {id: 'screwdriver', hashtags: ['screwdriver']}, {id: 'server', hashtags: ['server']}, {id: 'seven', hashtags: ['seven']}, {id: 'share-extra', hashtags: ['share']}, {id: 'shovel', hashtags: ['shovel']}, {id: 'shower', hashtags: ['shower']}, {id: 'signal', hashtags: ['signal']}, {id: 'silicone-syringe', hashtags: ['silicone']}, {id: 'simulation-01-block-foundation', hashtags: ['simulation']}, {id: 'simulation-02-strip-foundation', hashtags: ['simulation']}, {id: 'simulation-03-bottom-connector', hashtags: ['simulation']}, {id: 'simulation-04-column', hashtags: ['simulation']}, {id: 'simulation-05-top-connector', hashtags: ['simulation']}, {id: 'simulation-06-beam', hashtags: ['simulation']}, {id: 'simulation-07-gutter', hashtags: ['simulation']}, {id: 'simulation-08-roof-connector', hashtags: ['simulation']}, {id: 'simulation-09-roof', hashtags: ['simulation']}, {id: 'simulation-10-wall', hashtags: ['simulation']}, {id: 'simulation-11-floor', hashtags: ['simulation']}, {id: 'sink', hashtags: ['sink']}, {id: 'skull', hashtags: ['skull']}, {id: 'slab-thin', hashtags: ['slab']}, {id: 'slab-negative', hashtags: ['slab']}, {id: 'slab', hashtags: ['slab']}, {id: 'smartphone', hashtags: ['smartphone']}, {id: 'smoothing', hashtags: ['smoothing']}, {id: 'snow-flake', hashtags: ['snow']}, {id: 'snow-flake-variation', hashtags: ['snow']}, {id: 'solar-pannel', hashtags: ['solar']}, {id: 'spade', hashtags: ['spade']}, {id: 'spark', hashtags: ['spark']}, {id: 'sparkle', hashtags: ['sparkle']}, {id: 'sparkling-wine', hashtags: ['sparkling']}, {id: 'spirit-level-zoomed-in', hashtags: ['spirit']}, {id: 'spirit-level', hashtags: ['spirit']}, {id: 'sprinkler-alternative', hashtags: ['sprinkler']}, {id: 'sprinkler', hashtags: ['sprinkler']}, {id: 'stage', hashtags: ['stage']}, {id: 'stairs-massive', hashtags: ['stairs']}, {id: 'stairs-perspective', hashtags: ['stairs']}, {id: 'stairs-perspective-flight', hashtags: ['stairs']}, {id: 'stairs', hashtags: ['stairs']}, {id: 'star', hashtags: ['star']}, {id: 'steel-stage', hashtags: ['steel']}, {id: 'stonemason', hashtags: ['stonemason']}, {id: 'street', hashtags: ['street']}, {id: 'suitcase', hashtags: ['suitcase']}, {id: 'sun', hashtags: ['sun']}, {id: 'tape-measure', hashtags: ['tape']}, {id: 'tape', hashtags: ['tape']}, {id: 'thermometer-cold', hashtags: ['thermometer']}, {id: 'thermometer-hot', hashtags: ['thermometer']}, {id: 'tile-multiple', hashtags: ['tile']}, {id: 'tile-placing', hashtags: ['tile']}, {id: 'tile', hashtags: ['tile']}, {id: 'toilet-front', hashtags: ['toilet']}, {id: 'toilet-large', hashtags: ['toilet']}, {id: 'toilet', hashtags: ['toilet']}, {id: 'toolbox-flat', hashtags: ['toolbox']}, {id: 'toolbox-rounded', hashtags: ['toolbox']}, {id: 'toolbox-wooden', hashtags: ['toolbox']}, {id: 'train', hashtags: ['train']}, {id: 'tram', hashtags: ['tram']}, {id: 'truck-concrete-mixer', hashtags: ['truck']}, {id: 'truck-container', hashtags: ['truck']}, {id: 'truck-heavy', hashtags: ['truck']}, {id: 'truck-loaded', hashtags: ['truck']}, {id: 'truck', hashtags: ['truck']}, {id: 'tunnel-blasting', hashtags: ['tunnel']}, {id: 'tunnel-drilling', hashtags: ['tunnel']}, {id: 'tunnel-injection', hashtags: ['tunnel']}, {id: 'tunnel-profile-blasting', hashtags: ['tunnel']}, {id: 'tunnel-profile-ceiling', hashtags: ['tunnel']}, {id: 'tunnel-profile-dislodging', hashtags: ['tunnel']}, {id: 'tunnel-profile-drilling', hashtags: ['tunnel']}, {id: 'tunnel-profile-loading', hashtags: ['tunnel']}, {id: 'tunnel-profile-survey', hashtags: ['tunnel']}, {id: 'tunnel-profile-ventilating', hashtags: ['tunnel']}, {id: 'underfloor-heating', hashtags: ['underfloor']}, {id: 'ventilation-half-circles', hashtags: ['ventilation']}, {id: 'ventilation', hashtags: ['ventilation']}, {id: 'waggon', hashtags: ['waggon']},{id: 'wall-brick-large', hashtags: ['wall']}, {id: 'wall-brick', hashtags: ['wall']}, {id: 'wall-curtain', hashtags: ['wall']}, {id: 'wall-perspective', hashtags: ['wall']}, {id: 'wall-plastered', hashtags: ['wall']}, {id: 'wall-unfinished', hashtags: ['wall']}, {id: 'wallet', hashtags: ['wallet']}, {id: 'wallpaper', hashtags: ['wallpaper']}, {id: 'water-drop', hashtags: ['water']}, {id: 'water-tap-large', hashtags: ['water']}, {id: 'water-tap-medium', hashtags: ['water']}, {id: 'water-tap-small', hashtags: ['water']}, {id: 'weight', hashtags: ['weight']}, {id: 'welding-machine', hashtags: ['welding']}, {id: 'welding-mask', hashtags: ['welding']}, {id: 'wheel-barrow', hashtags: ['wheel']}, {id: 'window-casement', hashtags: ['window']}, {id: 'window-double-hung', hashtags: ['window']}, {id: 'window-perspective', hashtags: ['window']}, {id: 'window-rounded', hashtags: ['window']}, {id: 'window-square', hashtags: ['window']}, {id: 'worker-shovel', hashtags: ['worker']}, {id: 'worker-sledgehammer', hashtags: ['worker']}, {id: 'wrecking-ball', hashtags: ['wrecking']}, {id: 'wrench', hashtags: ['wrench']},
  ],
  icons_old_new: [
    {old: 'obj-building', new: 'house-split'},{old: 'tool-wrench', new: 'wrench'},{old: 'human-worker', new: 'worker-shovel'},{old: 'obj-window', new: 'window-square'},{old: 'vehicle-wheelbarrow', new: 'wheel-barrow'},{old: 'obj-drop', new: 'water-drop'},{old: 'obj-drop-white', new: 'water-drop'},{old: 'obj-brick-wall', new: 'wall-unfinished'},{old: 'obj-brick-wall-2', new: 'wall-plastered'},{old: 'symbol-ventilation-2', new: 'ventilation'},{old: 'vehicle-truck-mining', new: 'truck-loaded'},{old: 'vehicle-truck-delivery-3', new: 'truck-heavy'},{old: 'vehicle-truck-delivery', new: 'truck-container'},{old: 'vehicle-truck-mixer', new: 'truck-concrete-mixer'},{old: 'vehicle-truck-delivery-2', new: 'truck'},{old: 'sign-weather', new: 'thermometer-cold'},{old: 'sign-weather-white', new: 'thermometer-cold'},{old: 'symbol-stone-cutter', new: 'stonemason'},{old: 'sign-accessibility', new: 'person-standing'},{old: 'obj-structure', new: 'stage'},{old: 'symbol-electro', new: 'spark'},{old: 'symbol-cold', new: 'snow-flake'},{old: 'obj-floor-coating', new: 'slab-negative'},{old: 'obj-floor-screed', new: 'slab-negative'},{old: 'obj-floor', new: 'slab'},{old: 'sign-toxic', new: 'skull'},{old: 'symbol-connection', new: 'signal'},{old: 'symbol-share', new: 'share-extra'},{old: 'obj-server', new: 'server'},{old: 'tool-screw', new: 'screw'},{old: 'obj-display', new: 'screen'},{old: 'tools-saw-log', new: 'sawing'},{old: 'obj-roof', new: 'roof-profile'},{old: 'obj-floor-double', new: 'raised-floor'},{old: 'obj-radiator', new: 'radiator-rectangle'},{old: 'obj-traffic-cone', new: 'pylon'},{old: 'obj-plug-3', new: 'power-plug-slim'},{old: 'obj-plug-2', new: 'power-plug-sharp'},{old: 'obj-plug', new: 'power-plug-rounded'},{old: 'obj-drainage-pipe', new: 'pouring-horizontal'},{old: 'tool-planer', new: 'plane'},{old: 'obj-construction-plan', new: 'plan'},{old: 'obj-phone', new: 'phone'},{old: 'sign-weather-3', new: 'perspective-walls'},{old: 'human-stars', new: 'person-stars'},{old: 'human-helmet', new: 'person-helmet'},{old: 'human-king', new: 'person-crowned'},{old: 'human-king-2', new: 'person-crowned'},{old: 'tool-paint-roller-2', new: 'paint-roller-negative'},{old: 'tool-paint-roller', new: 'paint-roller'},{old: 'tool-paint-bucket', new: 'paint-bucket'},{old: 'tool-paint-brush', new: 'paint-brush'},{old: 'obj-phone-mobile', new: 'mobile-phone'},{old: 'obj-mic', new: 'microphone'},{old: 'obj-bullhorn', new: 'megaphone'},{old: 'tool-ruler', new: 'measure'},{old: 'symbol-link', new: 'link'},{old: 'obj-light-bulb', new: 'light-bulb-pear'},{old: 'obj-roof-2', new: 'house-flat-roof'},{old: 'obj-roof-3', new: 'house-chimney'},{old: 'obj-roof-3-white', new: 'house-chimney'},{old: 'tool-hammer', new: 'hammer'},{old: 'obj-cogs', new: 'gears'},{old: 'obj-cog', new: 'gear'},{old: 'obj-floor-2', new: 'floors'},{old: 'obj-floor-3', new: 'floors'},{old: 'sign-fire-2', new: 'flame-negative'},{old: 'sign-fire', new: 'flame'},{old: 'sign-warning', new: 'exclamation-triangle-negative'},{old: 'sign-warning-2', new: 'exclamation-triangle'},{old: 'sign-attention', new: 'exclamation-octagon'},{old: 'vehicle-excavator-2', new: 'excavator-large'},{old: 'vehicle-excavator', new: 'excavator'},{old: 'obj-barbell', new: 'dumbbell'},{old: 'symbol-layer', new: 'drywall'},{old: 'symbol-sanitation', new: 'droplet-splash'},{old: 'obj-window-2', new: 'door-open'},{old: 'obj-door', new: 'door'},{old: 'symbol-ventilation', new: 'cycle'},{old: 'tool-cutter', new: 'cutter'},{old: 'obj-package-3', new: 'cube-top'},{old: 'obj-brick', new: 'cube-nubs'},{old: 'obj-package-2', new: 'cube-negative'},{old: 'obj-package-4', new: 'cube'},{old: 'tools-pipe-wrench-screwdriver', new: 'crossed-wrench-screwdriver'},{old: 'tools-pencil-ruler', new: 'crossed-pencil-ruler'},{old: 'tools-hammer-screwdriver', new: 'crossed-hammer-screwdriver'},{old: 'vehicle-crane', new: 'crane'},{old: 'obj-couch', new: 'couch'},{old: 'sign-steam', new: 'con-rod-negative'},{old: 'sign-weather-4', new: 'clouds-lightning'},{old: 'sign-x', new: 'close-octagon'},{old: 'obj-clock', new: 'clock-negative'},{old: 'obj-clock-2', new: 'clock'},{old: 'tool-trowel', new: 'cleaning-trowel-triangle'},{old: 'tool-paint-brush-clean', new: 'cleaning'},{old: 'tools-axe-logs', new: 'chopping'},{old: 'obj-package', new: 'carton'},{old: 'obj-camera-2', new: 'camera-simple'},{old: 'obj-camera', new: 'camera'},{old: 'obj-bin', new: 'bin'},{old: 'obj-t-beam', new: 'beam-short'},{old: 'obj-steel', new: 'beam-long'},{old: 'symbol-resize', new: 'area'},{old: 'sign-radio-waves', new: 'antenna'},{old: 'sign-weather-2', new: 'air'},{old: 'sign-weather-2-white', new: 'air'},{old: 'bretzel', new: 'pretzel'},
  ],
  booking_units: [
    {value: 'hours', text: 'hours', name: 'hours', unit: 'hours'},
    {value: 'm^2', text: 'm^2', name: 'm^2', unit: 'm^2'},
    {value: 'm^3', text: 'm^3', name: 'm^3', unit: 'm^3'},
    {value: 'count', text: 'count', name: 'count', unit: 'count'},
  ],
  machinestep_types: [
    {color: 'grey lighten-5', icon: 'checked-stopwatch', value: 'other', text: 'other', name: 'other', unit: 'other'},

    // Lifting
    {color: 'grey lighten-4', icon: 'construction-crane', value: 'Tower Crane', text: 'Tower Crane', name: 'Tower Crane', unit: 'Tower Crane'},
    {color: 'grey lighten-3', icon: 'crane', value: 'Mobile Crane', text: 'Mobile Crane', name: 'Mobile Crane', unit: 'Mobile Crane'},
    {color: 'grey lighten-2', icon: 'scissor-lift', value: 'Lifting Platform', text: 'Lifting Platform', name: 'Lifting Platform', unit: 'Lifting Platform'},
    {color: 'grey lighten-1', icon: 'scissor-lift', value: 'Inclined Lift', text: 'Inclined Lift', name: 'Inclined Lift', unit: 'Inclined Lift'},

    // Elevator
    {color: 'grey', icon: 'elevator', value: 'Elevator', text: 'Elevator', name: 'Elevator', unit: 'Elevator'},
    {color: 'grey darken-1', icon: 'elevator', value: 'Construction Elevator', text: 'Construction Elevator', name: 'Construction Elevator', unit: 'Construction Elevator'},

    // Transportation
    {color: 'grey darken-2', icon: 'truck', value: 'Truck', text: 'Truck', name: 'Truck', unit: 'Truck'},
    {color: 'grey darken-3', icon: 'truck-container', value: 'Pallet Truck', text: 'Pallet Truck', name: 'Pallet Truck', unit: 'Pallet Truck'},
    {color: 'grey darken-4', icon: 'fork-lift', value: 'Forklift', text: 'Forklift', name: 'Forklift', unit: 'Forklift'},

    // Storage
    {color: 'blue-grey lighten-1', icon: 'area-shaded', value: 'Laydown Area', text: 'Laydown Area', name: 'Laydown Area', unit: 'Laydown Area'},
    {color: 'blue-grey lighten-2', icon: 'container-perspective', value: 'Container', text: 'Container', name: 'Container', unit: 'Container'},

    // Other
    {color: 'blue-grey lighten-3', icon: 'concrete-mixer', value: 'Concrete Mixer', text: 'Concrete Mixer', name: 'Concrete Mixer', unit: 'Concrete Mixer'},
    {color: 'blue-grey lighten-4', icon: 'excavator', value: 'Excavator', text: 'Excavator', name: 'Excavator', unit: 'Excavator'},
  ],
  project_states: [
    {
      value: 'planning',
      id: 'planning',
      icon: 'watch-pie-chart',
      restricted: false,
    },
    {
      value: 'live',
      id: 'live',
      icon: 'play',
      restricted: true,
    },
    {
      value: 'paused',
      id: 'paused',
      icon: 'pause',
      restricted: true,
    },
    {
      value: 'terminated',
      id: 'terminated',
      icon: 'check',
      restricted: true,
    },
  ],
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getUObjects: (state) => (payload) => {
    if (payload.ids) {
      return payload.ids.map(id => state[payload.type][id]);
    } else if (payload.types) {
      let array = [];
      payload.types.forEach(type => {
        array = array.concat(Object.keys(state[type]).map(id => state[type][id]));
      });
      return array;
    } else {
      return Object.keys(state[payload.type]).map(id => state[payload.type][id]);
    }
  },
  getUObjectParent: (state) => (payload) => {
    for (let key in state[payload.parent_type]) {
      if (state[payload.parent_type][key][payload.type] && state[payload.parent_type][key][payload.type].includes(payload.id)) {
        return state[payload.parent_type][key];
      }
    }
    return {};
  },
  getUObjectsFiltered: (state, getters, rootState, rootGetters) => (payload) => {
    let array = [];
    if (payload.ids) {
      array = payload.ids.map(id => state[payload.type][id]);
    } else if (payload.types) {
      payload.types.forEach(type => {
        if (payload.workbench && ['csequences', 'cworkpackages'].includes(type)) {
          array = array.concat(Object.keys(state[type])
            .map(id => state[type][id])
            .filter(object => object.likes.findIndex(like => like.user.id === rootGetters['Auth/getUserId']) !== -1
          ));
        } else {
          array = array.concat(Object.keys(state[type]).map(id => state[type][id]));
        }
      });
    } else {
      array = Object.keys(state[payload.type]).map(id => state[payload.type][id]);
    }
    return array.filter(object => {
      let boolean = true;
      if (payload.search) {
        boolean = false;
      }
      for (let prop in payload.search) {
        if (object[prop].toLowerCase().includes(payload.search[prop].toLowerCase())) {
          boolean = true;
        }
      }
      for (let prop in payload.filter) {
        if (prop === 'owner' && object[prop].id !== payload.filter[prop].id) {
          boolean = false;
        } else if (prop !== 'owner' && object[prop] !== payload.filter[prop]) {
          boolean = false;
        }
      }
      return boolean;
    });
  },
  getUObject: (state) => (payload) => {
    return state[payload.type][payload.id];
  },
  getUrl: () => (payload) => {
    let payload_copy = JSON.parse(JSON.stringify(payload));
    let url = '';
    if (payload_copy.url_prefix) {
      url = payload_copy.url_prefix;
    }
    //takt-space
    if (payload_copy.url.length > 1 && ['sites', 'spatialzones', 'buildings', 'buildingstoreys', 'spacegroups', 'elements'].includes(Object.keys(payload_copy.url[1])[0])) {
      payload_copy.url.splice(0,1);
    }
    payload_copy.url.forEach(entry =>
      url = `${url}${Object.keys(entry)[0].substring(0, 4) !== 'show'? '/':'?show='}${Object.keys(entry)[0]}${Object.values(entry)[0] !== ''?`/${Object.values(entry)[0]}`:''}`
    );
    if (payload.url_suffix) {
      url = `${url}${payload.url_suffix}`;
    }
    return url;
  },
  isUObjEmpty: (state) => (payload) => {
    return Object.entries(state[payload]).length === 0;
  },
  getCache: (state) => { return state.cache; },
  getWrapperIcon: () => (type) => {
    const iconByType = {
      // IFC Wrapper
      projects: 'takt-plan',
      sites: 'site-top-down',
      spatialzones: 'area-shaded',
      buildings: 'construction',
      buildingstoreys: 'construction-story',
      spacegroups: 'room-3d',
      elementassemblies: 'component-cubes',

      // Project Wrapper
      trains: 'takt-plan-train',
      taktareas: 'takt-plan-sequence',
      twaggons: 'takt-plan-waggon',
      tworkpackages: 'takt-plan-workpackage',
      tworksteps: 'person-helmet',

      // Other Wrapper
      plans: 'plan',
    };
  
    if (type in iconByType) {
      return iconByType[type];
    } else {
      // Fallback value to return when the key is not found.
      return 'area-empty';
    }
  },

  getIFCElementIcon: (state, getters) => (name) => {
    let parts = name.split(' '); // Split the string at the space character
    let partBeforeSpace = parts[0];    // Get the first element of the array
    return getters.getIFCElementIconByName(partBeforeSpace);
  },
  getObjectWrapperIcon: (state, getters) => (name) => {
    name = name.slice(0, -1);
    // Check first if it's any other than IFC
    if(name === "tworksteps"){
      return 'person-helmet';
    }
    return getters.getIFCElementIconByName(name);
  },
  getIFCElementIconByName: () => (ifc_name) => {
    const iconByType = {
      "IFCBEAM": 'beam-long',
      "IFCBEARING": 'bridge-bearing',
      "IFCBUILDINGELEMENTPROXY": 'proxy',
      "IFCCHIMNEY": 'chimney-masonry',
      "IFCCOLUMN": 'column',
      "IFCCOURSE": 'course',
      "IFCCOVERING": 'covering',
      "IFCCURTAINWALL": 'curtain-wall',
      "IFCDEEPFUNDATION": 'deep-foundation',
      "IFCDOOR": 'door-open',
      "IFCEARTHWORKSELEMENT": 'earthworks',
      "IFCFOOTING": 'footing',
      "IFCKERB": 'kerb',
      "IFCMEMBER": 'persons-two',
      "IFCMOORINGDEVICE": 'mooring-device',
      "IFCNAVIGATIONELEMENT": 'beacon',
      "IFCPAVEMENT": 'pavement',
      "IFCPLATE": 'plate',
      "IFCRAILING": 'railing',
      "IFCRAMP": 'ramp',
      "IFCRAMPFLIGHT": 'ramp-flight',
      "IFCROOF": 'roof-profile',
      "IFCSHADINGDEVICE": 'shading-device',
      "IFCSLAB": 'slab-thin',
      "IFCSTAIR": 'stairs-perspective-flight',
      "IFCSTAIRFLIGHT": 'stairs-perspective',
      "IFCTRACKELEMENT": 'rail-tracks',
      "IFCWALL": 'wall-brick',
      "IFCWINDOW": 'window-casement'
    };
    
    if (ifc_name in iconByType) {
      return iconByType[ifc_name];
    } else {
      // Fallback value to return when the key is not found.
      return 'column-rounded';
    }
  }
};

// Actions
const actions = {
  undoLastAction({dispatch, commit}){
    if (state.action_stack.length) {
      let last_action = state.action_stack[state.action_stack.length-1];
      last_action.payload.ignore_action_stack = true;
      dispatch(last_action.action, last_action.payload);
      commit('pop_action_from_stack');
    }
  },
  /*eslint no-empty-pattern: "off"*/
  getXML({}, payload) {
    axios({
      url: 'projects/' + payload.project_id + '/downloadxml',
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${payload.project_name}.${payload.file_extension}`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  requestUObject({ commit, getters, rootState, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      let headers = {
        'Cache-Control': 'no-cache'
      };
      if (rootGetters['Auth/isCloudPrint']) {
        headers.TAKTCloudprintToken = rootState.Auth.cloudprint_token;
      }
      let url = getters.getUrl(payload);
      if ( !payload.no_cache && getters.getCache[url] && new Date().getTime() < getters.getCache[url].time_expired ) {
      // if ( getters.getCache[url] && new Date().getTime() < getters.getCache[url].time_expired ) {
        resolve();
      } else {
        axios({
          url: url,
          method: 'GET',
          headers: headers,
        })
        .then(resp => {
          // if meta_data is defined, then commit meta_data
          if (resp.data.meta_data) {
            // commit meta_data, key is the key of the last object in the url array unless that key is "showWithEntitiesNormalized", then it is the 2nd to last key
            let key = Object.keys(payload.url[payload.url.length-1])[0];
            if (key === 'showWithEntitiesNormalized') {
              key = Object.keys(payload.url[payload.url.length-2])[0];
            }
            commit('set_meta_data', {key: key, data: resp.data.meta_data});
          }
          payload.resp_data = resp.data.data;
          commit('create_u_objects', {rootState, payload});
          if (payload.add_u_object) {
            commit('add_u_object', payload);
          }
          commit('set_cache', url);
          resolve(resp);
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
      }
    });
  },
  createUObject({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      let data = {
        edit_key: rootState.Project.edit_key
      };
      if (payload.bulk) {
        data = Object.assign(data, payload.bulk.targets, payload.bulk.parents);
      } else {
        data = Object.assign(data, payload.u_object);
      }
      axios({
        url: getters.getUrl(payload),
        method: 'POST',
        data: payload.image?payload.image:data,
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
      .then(resp => {
        if (payload.call_only) {
          // skip all mutations...
          resolve(resp.data.data);
        } else {
          // payload.resp_data = {wworkpackageimages: [resp.data.data]};
          payload.resp_data = resp.data.data;
          commit('create_u_objects', {rootState, payload});
          if (payload.url.length > 2) {
            commit('add_u_object', payload);
          }
          if (payload.url.length > 1) {
            if ( Object.keys(payload.url[payload.url.length-2])[0].includes('extendwp') ) {
              resolve(resp.data.data['tworkpackages'][0].id);
              if (!payload.ignore_action_stack) {
                let bulk = false;
                let url_copy = JSON.parse(JSON.stringify(payload.url));
                url_copy.pop(); // remove showWithEntitiesNormalized
                url_copy.pop(); // remove extendwp
                if (payload.bulk) {
                  url_copy.push({'deletebulk': ''});
                  bulk = {
                    targets: { twaggons: []},
                    parents: { taktareas: []},
                  }
                  payload.resp_data.twaggons.forEach(obj => {
                    bulk.targets.twaggons.push(obj.id);
                    bulk.parents.taktareas.push(obj.parent.id);
                  });
                } else {
                  url_copy.pop(); // remove twaggons: id
                  url_copy.push({twaggons: payload.resp_data.twaggons[0].id}); // undo is deleting the new twaggon
                }
                commit('add_action_to_stack', {
                  action: 'deleteUObject',
                  payload: {
                    url: url_copy,
                    bulk: bulk,
                  }
                })
              }
            } else {
              // quick fix, clean up later commented by phil
              let steps_index = Object.keys(payload.url[payload.url.length-2])[0].indexOf('steps');
              if (steps_index !== -1) {
                let twp_id = payload.url[payload.url.length-3].tworkpackages;
                let prefix = 't';
                let step_count_key = Object.keys(payload.url[payload.url.length-2])[0].substring(0,steps_index) + '_step_count';
                if ( Object.keys(payload.url[1])[0].includes('wbgroups') ) {
                  prefix = 'wb';
                  twp_id = payload.url[payload.url.length-3].wbworkpackages;
                }
                commit('increase_step_count', {prefix, twp_id, step_count_key});
              }

              if (Object.keys(payload.url[payload.url.length-(2)])[0] === 'createbulk') {
                resolve(resp.data.data[Object.keys(payload.url[payload.url.length-(3)])][0].id);
                if (!payload.ignore_action_stack) {
                  const target_key = Object.keys(payload.url[payload.url.length-(3)])[0];
                  const parent_key = resp.data.data[target_key][0].parent.type;
                  let url_copy = JSON.parse(JSON.stringify(payload.url));
                  url_copy.pop();
                  url_copy.pop();
                  url_copy.pop();
                  url_copy.push({[target_key]: 0});
                  url_copy.push({'deletebulk': ''});
                  let targets = {
                    [target_key]: [],
                  };
                  let parents = {
                    [parent_key]: []
                  };
                  resp.data.data[target_key].forEach(obj => {
                    targets[target_key].push(obj.id);
                    parents[parent_key].push(obj.parent.id);
                  });
                  commit('add_action_to_stack', {
                    action: 'deleteUObject',
                    payload: {
                      url: url_copy,
                      bulk: { targets: targets, parents: parents },
                    }
                  })
                }
              } else {
                resolve(resp.data.data[Object.keys(payload.url[payload.url.length-(2)])][0].id);
                if (!payload.ignore_action_stack) {
                  let url_copy = JSON.parse(JSON.stringify(payload.url));
                  if(Object.values(payload.url[payload.url.length-(2)])[0] === 'copytaktareabulk') {
                    url_copy.pop();
                    url_copy.pop();
                    url_copy.push({'taktareas': 0});
                    url_copy.push({'deletebulk': ''});
                    payload.bulk = {
                      parents: { trains: []},
                      targets: { taktareas: []}
                    }
                    resp.data.data.taktareas.forEach(obj => {
                      payload.bulk.targets.taktareas.push(obj.id);
                      payload.bulk.parents.trains.push(obj.parent.id);
                    });
                  } else {
                    url_copy.pop();
                    url_copy.pop();
                    url_copy.push({[Object.keys(payload.url[payload.url.length-(2)])[0]]: resp.data.data[Object.keys(payload.url[payload.url.length-(2)])[0]][0].id});
                  }

                  commit('add_action_to_stack', {
                    action: 'deleteUObject',
                    payload: {
                      url: url_copy,
                      bulk: payload.bulk,
                    }
                  })
                }
              }
            }
          } else {
            resolve(resp.data.data);
          }
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  createUObjectFromUndo({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      let data = {
        edit_key: rootState.Project.edit_key
      };
      if (payload.bulk) {
        data = Object.assign(data, payload.bulk.targets, payload.bulk.parents);
        payload.url.pop();
        payload.url.push({'createfromundobulk': ''});
      } else {
        data = Object.assign(data, payload.u_object);
        payload.url.push({'createfromundo': ''});
      }
      axios({
        url: getters.getUrl(payload),
        method: 'POST',
        data: payload.image?payload.image:data,
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
      .then(resp => {


        if(payload.bulk) {
          payload.url.push({'something': 'something'});
        }

        // payload.resp_data = {wworkpackageimages: [resp.data.data]};
        payload.resp_data = resp.data.data;
        commit('create_u_objects', {rootState, payload});
        if (payload.url.length > 2) {
          commit('add_u_object', payload);
        }
        if (payload.url.length > 1) {
          if ( Object.keys(payload.url[payload.url.length-2])[0].includes('extendwp') ) {
            resolve(resp.data.data['tworkpackages'][0].id);
          } else {
            if (Object.keys(payload.url[payload.url.length-(1)])[0] === 'something') {
              resolve(resp.data.data[Object.keys(payload.url[payload.url.length-(3)])][0].id);
            } else {
              resolve(resp.data.data[Object.keys(payload.url[payload.url.length-(2)])][0].id);
            }
          }
        } else {
          resolve(resp.data.data);
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  updateUObject({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      let data = {};
      if(payload.use_edit_key === true || typeof payload.use_edit_key === 'undefined'){
        data.edit_key = rootState.Project.edit_key;
      }
      let old_values = {};
      if (payload.bulk) {
        let target_key = Object.keys(payload.url[payload.url.length-2])[0];
        old_values.targets = payload.bulk.targets;
        old_values.updates = [];
        for (var i = 0; i < payload.bulk.updates.length; i++) {
          let update = {};
          for (var k = 0; k < Object.keys(payload.bulk.updates[i]).length; k++) {
            if (rootState.Ultra[target_key][payload.bulk.targets[target_key][i]]) {
              update[Object.keys(payload.bulk.updates[i])[k]] = JSON.parse(JSON.stringify(rootState.Ultra[target_key][payload.bulk.targets[target_key][i]][Object.keys(payload.bulk.updates[i])[k]]));
            } else {
              // value is not in store, so we assume it has the same old value as the initial entity's value
              // iterate over rootState.Ultra.action_stack and find the last updateUObject action
              for (var h = rootState.Ultra.action_stack.length-1; h >= 0; h--) {
                const action = rootState.Ultra.action_stack[h];
                if ( action.action === 'updateUObject' ) {
                  const parent_helper_key = Object.keys(payload.url[payload.url.length-3])[0]; // e.g. tworkpackages
                  const parent_helper_value = Object.values(payload.url[payload.url.length-3])[0]; // e.g. tworkpackages
                  const target_helper_key = Object.keys(payload.url[payload.url.length-2])[0]; // e.g. tqualitysteps

                  // action.url: the key at length -1 has to be target_helper_key
                  // action.url: they key and the value at length -2 has to parent_helper_key and parent_helper_value
                  if( Object.keys(action.payload.url[action.payload.url.length-1])[0] === target_helper_key &&
                      Object.keys(action.payload.url[action.payload.url.length-2])[0] === parent_helper_key &&
                      Object.values(action.payload.url[action.payload.url.length-2])[0] === parent_helper_value 
                  ) {
                    // found the correct action, now get the old value from the payload
                    update = action.payload.update;
                    break;
                  }
                }
              }
            }
          }
          old_values.updates.push(update);
        }
        data = Object.assign(data, payload.bulk.targets);
        data.updates = payload.bulk.updates;
      } else {
        if (!payload.call_only) {
          for (var j = 0; j < Object.keys(payload.update).length; j++) {
            let update_key = Object.keys(payload.update)[j];
            let obj = rootState.Ultra[Object.keys(payload.url[payload.url.length-1])[0]][Object.values(payload.url[payload.url.length-1])[0]];
            if (obj && (obj[update_key] || obj[update_key] === false || obj[update_key] === 0 || obj[update_key] === '' || obj[update_key] === null)) {
              old_values[update_key] = JSON.parse(JSON.stringify(obj[update_key]));
            }
          }
        }
        data = Object.assign(data, payload.update);
      }
      if (!payload.call_only) {
        commit('update_u_object', {rootState, payload});
        if (!payload.ignore_action_stack) {
          commit('add_action_to_stack', {
            action: 'updateUObject',
            payload: {
              url: payload.url,
              update: old_values,
              bulk: payload.bulk ? old_values : false,
            }
          })
        }
      }
      payload.update = old_values;
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: data,
      })
      .then(resp => {
        if (resp.data) {
          commit('Autopilot/set_autopilots', resp.data.autopilot_data, { root: true });
        }
        resolve();
      })
      .catch(err => {
        if (!payload.call_only) {
          commit('update_u_object', {rootState, payload});
        }
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  updateUObjectPosition({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      // commit before call due to performance
      commit('update_u_object_position', payload);
      let data = {
        edit_key: rootState.Project.edit_key
      };
      if (payload.bulk) {
        data = Object.assign(data, payload.bulk.targets);
        data.updates = payload.bulk.updates;

        if (!payload.ignore_action_stack) {

          let payload_copy = JSON.parse(JSON.stringify(payload));
          for (let index = 0; index < payload_copy.bulk.updates.length; index++) {
            payload_copy.bulk.updates[index].position = payload_copy.bulk.updates[index].position * (-1);
          }
          payload_copy.updates = payload_copy.bulk.updates;

          commit('add_action_to_stack', {
            action: 'updateUObjectPosition',
            payload: payload_copy
          })
        }

      } else {
        // INFO: calculate old array | not used in mutation
        let payload_copy = JSON.parse(JSON.stringify(payload));
        data = Object.assign(data, payload_copy.update);
        if (payload.update.position_twaggons) {
          let old_array = JSON.parse(JSON.stringify(payload.update.position_twaggons));
          let waggon_id = Object.values(payload.url[payload.url.length - 1])[0];
          let index = old_array.indexOf(waggon_id);
          old_array.splice(index, 1);
          old_array.splice(index - payload.update.position, 0, waggon_id);
          payload_copy.update.position_twaggons = old_array;
        }
        
        payload_copy.update.position = payload.update.position * (-1);
        
        if (!payload.ignore_action_stack) {
          commit('add_action_to_stack', {
            action: 'updateUObjectPosition',
            payload: payload_copy
          })
        }
      }
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: data
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        commit('update_u_object_position', payload);
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  updateUObjectParent({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      const entity_key = Object.keys(payload.url[payload.url.length-2])[0];
      const entity_id = Object.values(payload.url[payload.url.length-2])[0];
      let data = {
        edit_key: rootState.Project.edit_key
      };
      if (payload.bulk) {
        data.targets = payload.bulk.targets;
        data.parents = payload.bulk.parents;
  
        if (!payload.ignore_action_stack) {
          let payload_copy = JSON.parse(JSON.stringify(payload));
          payload_copy.bulk.old_parents = payload.bulk.parents;
          payload_copy.bulk.parents = payload.bulk.old_parents;
  
          commit('add_action_to_stack', {
            action: 'updateUObjectParent',
            payload: payload_copy
          })
        }
      } else {
        data = Object.assign(data, payload.update);
  
        if (!payload.ignore_action_stack) {
          const entity = rootState.Ultra[entity_key][entity_id];
          let payload_copy = JSON.parse(JSON.stringify(payload));
          payload_copy.url[payload_copy.url.length-3][entity.parent.type] = payload_copy.update.parent_id;
          payload_copy.update.parent_id = entity.parent.id;
          payload_copy.update.position = entity.position;
  
          commit('add_action_to_stack', {
            action: 'updateUObjectParent',
            payload: payload_copy
          })
        }
  
      }
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: data
      })
      .then(() => {
        commit('update_u_object_parent', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    })
  },
  updateUObjectRelations({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      let calls = [];
      if (!payload.local) {
        let data = {
          edit_key: rootState.Project.edit_key,
        };
        data = Object.assign(data, {[`${payload.action}#${payload.target_type}`]: payload.target_ids});
        calls.push(
          axios({
          url: getters.getUrl(payload),
          method: 'PUT',
          data: data,
        })
        );
      }
      Promise.all(calls).then(() => {
        commit('update_u_object_relations', {rootState, payload: payload});
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  deleteUObject({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      let data = {
        edit_key: rootState.Project.edit_key
      };
      if (payload.bulk) {
        data = Object.assign(data, payload.bulk.targets);
      }
      axios({
        url: getters.getUrl(payload),
        method: 'DELETE',
        headers: {
          'Cache-Control': 'no-cache'
        },
        data: data
      })
      .then(() => {
        if (payload.call_only) {
          // skip all mutations...
          commit('delete_u_object', payload);
          resolve();
        }else{
        if (payload.url.length > 1) {
          commit('remove_u_object', payload);
        }
        if (payload.url_prefix && payload.url_prefix.includes('projectstructure')) {
          const target = getters.getUObject({
            type: Object.keys(payload.url[0])[0],
            id: Object.values(payload.url[0])[0],
          })
          if (target) {
            commit('remove_u_object_direct', {
              parent_type: target.parent.type,
              parent_id: target.parent.id,
              target_type: target.type,
              target_id: target.id,
            });
          }
        }

        if (!payload.ignore_action_stack) {
          let payload_copy = JSON.parse(JSON.stringify(payload));
          commit('add_action_to_stack', {
            action: 'createUObjectFromUndo',
            payload: payload_copy
          })
        }

        // quick fix, clean up later
        let steps_index = Object.keys(payload.url[payload.url.length-1])[0].indexOf('steps');
        // quick fix for substeps != t...steps
        if (steps_index !== -1 && Object.keys(payload.url[payload.url.length-1])[0] != 'substeps') {
          let step_count_key = Object.keys(payload.url[payload.url.length-1])[0].substring(0,steps_index) + '_step_count';
          let prefix = 't';
          let twp_id = payload.url[payload.url.length-2].tworkpackages;
          if ( Object.keys(payload.url[1])[0].includes('wbgroups') ) {
            prefix = 'wb';
            twp_id = payload.url[payload.url.length-2].wbworkpackages;
          }
          commit('decrease_step_count', {prefix, twp_id, step_count_key});
        }
        commit('delete_u_object', payload);
        resolve();
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  //deprecated use updateUObjectRelations
  addUObjects({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      let data = {
        edit_key: rootState.Project.edit_key
      };
      data = Object.assign(data, payload.u_objects);
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: data,
      })
      .then(() => {
        commit('add_u_objects', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  //deprecated use updateUObjectRelations
  removeUObjects({commit, getters, rootState}, payload) {
    return new Promise((resolve, reject) => {
      let data = {
        edit_key: rootState.Project.edit_key
      };
      data = Object.assign(data, payload.u_objects);
      axios({
        url: getters.getUrl(payload),
        method: 'PUT',
        data: data,
      })
      .then(() => {
        commit('remove_u_objects', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  resetUState({commit}, payload) {
    commit('reset_u_state', payload);
  },
  resetActionStack({commit}) {
    commit('reset_action_stack');
  }
};

// Mutations
const mutations = {
  //object mutations
  create_u_objects(state, {rootState, payload}) {
    // let state_copy = JSON.parse(JSON.stringify(rootState.Ultra));
    let state_copy = rootState.Ultra;
    for (let prop in payload.resp_data) {
      payload.resp_data[prop].forEach(object => {
        if (state_copy[prop][object.id]) {
          Vue.set(state_copy[prop], object.id, Object.assign({}, state_copy[prop][object.id], object));
        } else if (state_copy.definitions[prop]) {
          let definition = JSON.parse(JSON.stringify(state_copy.definitions[prop]));
          Vue.set(state_copy[prop], object.id, Object.assign(definition, object));
        } else {
          Vue.set(state_copy[prop], object.id, object);
        }
      });
    }
    // rootState.Ultra = state_copy;
  },
  update_u_object(state, {rootState, payload}) {
    // let state_copy = rootState.Ultra;
    if (payload.bulk) {
      let target_key = Object.keys(payload.url[payload.url.length-2])[0];
      payload.bulk.updates.forEach((update, index) => {
        if (rootState.Ultra[target_key][payload.bulk.targets[target_key][index]]) {
          Object.assign(rootState.Ultra[target_key][payload.bulk.targets[target_key][index]], update);
        }
      });
    }
    else if (rootState.Ultra[Object.keys(payload.url[payload.url.length-1])[0]][Object.values(payload.url[payload.url.length-1])[0]]) {

      Object.assign(rootState.Ultra[Object.keys(payload.url[payload.url.length-1])[0]][Object.values(payload.url[payload.url.length-1])[0]], payload.update);
    }
  },
  update_u_object_position(state, payload) {
    if (payload.bulk) {
      let target_key = Object.keys(payload.url[payload.url.length-2])[0];
      let parent_key = Object.keys(payload.url[payload.url.length-3])[0];

      payload.bulk.targets[target_key].forEach((target_value, index) => {
        let parent_value = payload.bulk.parents[parent_key][index];

        let array = state[parent_key][parent_value][target_key];

        let old_index = array.indexOf(target_value);
        if (old_index !== -1) {
          let new_index = old_index + parseInt(payload.bulk.updates[index].position);
          if (new_index < 0) {
            new_index = 0;
          } else if (new_index > array.length-1) {
            new_index = array.length-1;
          }
          array.splice(new_index, 0, array.splice(old_index, 1)[0]);
        }
      });
    } else {
      let array;
      let old_index;
      let new_index;
      if (payload.trainsbacklogs) {
        array = state.projects[payload.url[0].projects].trainsbacklogs;
        old_index = payload.old_index;
        new_index = payload.new_index;
      } else {
        let target_key = Object.keys(payload.url[payload.url.length-1])[0];
        let target_value = Object.values(payload.url[payload.url.length-1])[0];
        let parent_key = Object.keys(payload.url[payload.url.length-2])[0];
        let parent_value = Object.values(payload.url[payload.url.length-2])[0];

        array = state[parent_key][parent_value][target_key];
        old_index = array.indexOf(target_value);
        new_index = old_index + parseInt(payload.update.position);

      }

      array.splice(new_index, 0, array.splice(old_index, 1)[0]);
    }
  },
  update_u_object_parent(state, payload) {
    if (payload.bulk) {
      let target_key = Object.keys(payload.url[payload.url.length-2])[0];
      let old_parent_key = Object.keys(payload.url[payload.url.length-3])[0];
      let new_parent_key = old_parent_key;

      payload.bulk.targets.forEach((target, index) => {
        let old_parent_value = payload.bulk.old_parents[index];
        let new_parent_value = payload.bulk.parents[index];

        let old_array = state[old_parent_key][old_parent_value][target_key];
        let new_array = state[new_parent_key][new_parent_value][target_key];

        let old_index = old_array.indexOf(target.id);

        old_array.splice(old_index, 1);
        if (target.position) {
          let new_index = target.position - parseInt(1);
          new_array.splice(new_index, 0, target.id);
        } else {
          new_array.push(target.id);
        }
      });
    } else {
      let target_key = Object.keys(payload.url[payload.url.length-2])[0];
      let target_value = Object.values(payload.url[payload.url.length-2])[0];

      let old_parent_key = Object.keys(payload.url[payload.url.length-3])[0];
      let new_parent_key = old_parent_key;
      if (payload.update.target_type) {
        new_parent_key = payload.update.target_type;
      }
      let old_parent_value = Object.values(payload.url[payload.url.length-3])[0];
      let new_parent_value = 0;
      //deprecated only in project structure
      if (payload.update.target_id) {
        new_parent_value = payload.update.target_id;
      } else {
        new_parent_value = payload.update.parent_id;
      }

      let old_array = state[old_parent_key][old_parent_value][target_key];
      let new_array = state[new_parent_key][new_parent_value][target_key];
      let old_index = old_array.indexOf(target_value);

      old_array.splice(old_index, 1);
      if (payload.update.position) {
        let new_index = payload.update.position - parseInt(1);
        new_array.splice(new_index, 0, target_value);
      } else {
        new_array.push(target_value);
      }
    }
  },
  delete_u_object(state, payload) {
    if (payload.bulk) {
      let target_key = Object.keys(payload.url[payload.url.length-2])[0];
      payload.bulk.targets[target_key].forEach(target_id => {
        if (state[target_key][target_id]) {
          Vue.delete(state[target_key], target_id);
        }
      });
    } else {
      let target_key = Object.keys(payload.url[payload.url.length-1])[0];
      let target_value = Object.values(payload.url[payload.url.length-1])[0];
      Vue.delete(state[target_key], target_value);
    }
  },
  //parent mutations
  add_u_object(state, payload) {
    if (payload.bulk) {
      let target_key = Object.keys(payload.url[payload.url.length-3])[0];
      let parent_key = Object.keys(payload.url[payload.url.length-4])[0];

      payload.bulk.targets[target_key].forEach((target_value, target_index) => {
        let parent_value = payload.bulk.parents[parent_key][target_index];
        if (!state[parent_key][parent_value][target_key]) {
          Vue.set(state[parent_key][parent_value], [target_key], []);
        }
        if (payload.resp_data[target_key][target_index].position) {
          state[parent_key][parent_value][target_key].splice(payload.resp_data[target_key][target_index].position-1, 0, payload.resp_data[target_key][target_index].id);
        }
        else {
          state[parent_key][parent_value][target_key].push(payload.resp_data[target_key][target_index].id);
        }
      });
    } else {
      let exceptions = ['extendwp'];
      let modifier = 0;
      if (exceptions.includes(Object.keys(payload.url[payload.url.length-2])[0])) {
        modifier++;
      }
      let target_key = Object.keys(payload.url[payload.url.length-(2+modifier)])[0];
      let parent_key = Object.keys(payload.url[payload.url.length-(3+modifier)])[0];
      let parent_value = Object.values(payload.url[payload.url.length-(3+modifier)])[0];
      if (!state[parent_key][parent_value][target_key]) {
        Vue.set(state[parent_key][parent_value], [target_key], []);
      }
      payload.resp_data[target_key].forEach(target => {
        if (!state[parent_key][parent_value][target_key].includes(target.id)) {
          if (target.position) {
            state[parent_key][parent_value][target_key].splice(target.position-1, 0, target.id);
            if (payload.trainsbacklogs) {
              let obj = {
                type: target_key,
                position: target.position,
                id: target.id,
              };
              state.projects[parent_value].trainsbacklogs.splice(target.position-1, 0, obj);
            }
          }
          else {
            state[parent_key][parent_value][target_key].push(target.id);
            if (payload.trainsbacklogs) {
              let obj = {
                type: target_key,
                position: state.projects[parent_value].trainsbacklogs.length+1,
                id: target.id,
              };
              state.projects[parent_value].trainsbacklogs.push(obj);
            }
          }
        }
      });

    }
  },
  remove_u_object_direct(state, payload) {
    const index = state[payload.parent_type][payload.parent_id][payload.target_type].indexOf(payload.target_id);
    if (index !== -1) {
      state[payload.parent_type][payload.parent_id][payload.target_type].splice(index, 1);
    }
  },
  remove_u_object(state, payload) {
    if (payload.bulk) {
      let target_key = Object.keys(payload.url[payload.url.length-2])[0];
      let parent_key = Object.keys(payload.url[payload.url.length-3])[0];
      payload.bulk.targets[target_key].forEach((target_value, target_index) => {
        let parent_value = payload.bulk.parents[parent_key][target_index];
        let index = state[parent_key][parent_value][target_key].indexOf(target_value);
        if (index !== -1) {
          state[parent_key][parent_value][target_key].splice(index, 1);
        }
      });
    }
    else {
      let target_key = Object.keys(payload.url[payload.url.length-1])[0];
      let target_value = Object.values(payload.url[payload.url.length-1])[0];
      let parent_key = Object.keys(payload.url[payload.url.length-2])[0];
      let parent_value = Object.values(payload.url[payload.url.length-2])[0];
      let index = state[parent_key][parent_value][target_key].indexOf(target_value);
      if (payload.trainsbacklogs) {
        let trainsbacklogs_index = state.projects[parent_value].trainsbacklogs.findIndex(tbl => tbl.id === target_value);
        state.projects[parent_value].trainsbacklogs.splice(trainsbacklogs_index, 1);
      }
      state[parent_key][parent_value][target_key].splice(index, 1);
    }
  },
  add_u_objects(state, payload) {
    let parent_key = Object.keys(payload.url[payload.url.length-2])[0];
    let parent_value = Object.values(payload.url[payload.url.length-2])[0];

    let target_key = payload.u_objects.target_type;
    let target_value = payload.u_objects.target_ids;

      if (payload.u_objects.start_index) {
        state[parent_key][parent_value][target_key].splice(payload.u_objects.start_index, 0, target_value);
      } else {
        state[parent_key][parent_value][target_key] = state[parent_key][parent_value][target_key].concat(target_value);
      }
  },
  remove_u_objects(state, payload) {
    let parent_key = Object.keys(payload.url[payload.url.length-2])[0];
    let parent_value = Object.values(payload.url[payload.url.length-2])[0];

    let target_key = payload.u_objects.target_type;
    let target_value = payload.u_objects.target_ids;

    target_value.forEach(id => {
      let index = state[parent_key][parent_value][target_key].indexOf(id);
      state[parent_key][parent_value][target_key].splice(index, 1);
    });
  },
  update_u_object_relations(state, {rootState, payload}) {
    let state_copy = JSON.parse(JSON.stringify(rootState.Ultra));

    let parent_key;
    let parent_values;
    let target_key;
    if (payload.bulk) {
      parent_key = payload.bulk.parent_type;
      parent_values = payload[parent_key];
      target_key = payload.bulk.target_type;
    } else {
      parent_key = Object.keys(payload.url[payload.url.length-1])[0];
      parent_values = Object.values(payload.url[payload.url.length-1]);
      target_key = payload.target_type;
    }
    parent_values.forEach((parent_value, index) => {
      let target_value;
      if (payload.bulk) {
        target_value = payload.updates[index][`${payload.action}#${target_key}`];
      } else {
        target_value = payload.target_ids;
      }
      if (payload.action === 'add') {
        if (state_copy[parent_key][parent_value]) {
          if (payload.start_index) {
            state_copy[parent_key][parent_value][target_key].splice(payload.u_objects.start_index, 0, target_value);
          } else {
            state_copy[parent_key][parent_value][target_key] = state_copy[parent_key][parent_value][target_key].concat(target_value);
          }
        }
        if (payload.bidirectional) {
          target_value.forEach(target_id => {
            if (state_copy[target_key][target_id]) {
              state_copy[target_key][target_id][parent_key].push(parent_value);
            }
          });
        }
      } else if (payload.action === 'remove') {
        target_value.forEach(target_id => {
          if (state_copy[parent_key][parent_value]) {
            let index = state_copy[parent_key][parent_value][target_key].indexOf(target_id);
            state_copy[parent_key][parent_value][target_key].splice(index, 1);
          }
          if (payload.bidirectional) {
            if (state_copy[target_key][target_id]) {
              let index_bi = state_copy[target_key][target_id][parent_key].indexOf(parent_value);
              state_copy[target_key][target_id][parent_key].splice(index_bi, 1);
            }
          }
        });
      }
    });
    rootState.Ultra = state_copy;
  },
  reset_u_state(state, payload) {
    Object.keys(state.cache).forEach(cache_key => {
      if (cache_key.startsWith('/projects/' + payload.params.project_id)) {
        delete state.cache[cache_key];
      }
    });
    payload.keys.forEach(key => {
      // TODO: reset cache for key
      Vue.set(state, key, initialState()[key]);
    });
    Vue.set(state, 'action_stack', []);
  },
  set_error(state, error) {
    state.error = error;
  },
  set_cache(state, url) {
    state.cache[url] = {
      time_expired: new Date().getTime() + 300000
    };
  },
  increase_step_count(state, payload){
    state[`${payload.prefix}workpackages`][payload.twp_id][payload.step_count_key]++;
  },
  decrease_step_count(state, payload){
    state[`${payload.prefix}workpackages`][payload.twp_id][payload.step_count_key]--;
  },
  // a vuex commit setting the meta data object by the given key
  set_meta_data(state, payload) {
    state.meta_data[payload.key] = payload.data;
  },
  add_action_to_stack(state, payload) {
    state.action_stack.push(payload);
    // if stack has more than 10 entries, remove the first one
    if (state.action_stack.length > 10) {
      state.action_stack.shift();
    }
    // console.log('action_stack', state.action_stack);
  },
  pop_action_from_stack(state) {
    state.action_stack.pop();
  },
  reset_action_stack(state){
    Vue.set(state, 'action_stack', []);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
